import React, { useState, useEffect,useRef} from "react";
import { Input, Select, Button,message,Modal,Radio,Checkbox } from "antd";
import { PlusCircleOutlined, DeleteOutlined,EllipsisOutlined,CopyOutlined,WarningOutlined,EyeOutlined } from "@ant-design/icons";
import { rebuildFormula } from "@/config/func";
// import test_Rectisol from "@/constants/test_Rectisol.json";
import test_Rectisol from "@/constants/defaultValue.json";
import { unitMap } from "@/constants/dataMap";

import {buildNodeTypeParamsForm,queryRelateElement} from "./func";

interface ParameterEditorProps {
  // 基础信息数据
  localFormData: Record<string, any>;
  setLocalFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 参数配置数据
  modalParams: any[] | null;
  localParamValues: Record<string, any>;
  setLocalParamValues: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 流股组分数据
  materialsData: any;
  localMaterialsData: Record<string, any>;
  setLocalMaterialsData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 辅助信息
  globalData?: any;
  selectElement: string;
  maxHeight:number | string;
  designVisible:boolean;
  fastModalVariable:boolean;
  closeFastModal:() => void;
  saveAbled:(saveAbled:boolean) => void;
  readonly?:any;
  isShowDescription?:boolean;
  elementPage?:string|null;

  selectedElementData:any;
  diagramInstance?:any;
  confirm:(oldParams) => void;
  cancel:() => void;
  changeOtherElement:(element) => void;
}

const ParameterEditor: React.FC<ParameterEditorProps> = ({
  localFormData,
  setLocalFormData,
  modalParams,
  localParamValues,
  setLocalParamValues,
  materialsData,
  localMaterialsData,
  setLocalMaterialsData,
  globalData,
  selectElement,
  maxHeight,
  designVisible,
  fastModalVariable,
  closeFastModal,
  saveAbled,
  readonly,
  isShowDescription,
  elementPage,

  selectedElementData,
  diagramInstance,
  confirm,
  cancel,
  changeOtherElement,
}) => {

  const [messageApi, contextHolder] = message.useMessage();
  const [modalVariable, setModalVariable] = useState(false);
  const [copyMaterialsDataTxt, setCopyMaterialsDataTxt] = useState("");
  const [errorInputs,setErrorInputs] = useState([]);

  const [initializeVariable,setInitializeVariable] = useState(false);     //初始化完成表示，若为true代表初始化完成，可以渲染前端组件
  const [paramDatas,setParamDatas] = useState(null);  //参数数据，该格式用于构建该页面
  const paramDatasRef = useRef(null);
  const trayCountBaseRef = useRef<number | null>(null);  //进入塔板数输入框时的原塔板数（编辑过程中保持不变）
  const trayLinkedFieldsRef = useRef<{engName:string;index:number;key:string}[]>([]);  //本次编辑已被联动修改的塔板相关字段
  const trayRangeCheckRef = useRef(false);  //是否校验塔板数越界（改过塔板数后启用）
  const [relateElements,setRelateElements] = useState({fromNodes:[],toNodes:[],allNodes:[],inLinks:[],outLinks:[],allLinks:[]});  //关联元件/流股/分组数据
  const [expandEffRow,setExpandEffRow] = useState([]);
  const [selectSpecModal,setSelectSpecModal] = useState({variable:false,index:null});
  const [specChecked,setSpecChecked] = useState<string[]>([]);  //选择特殊效率弹窗勾选的组分（组分中文名）
  const specOriginChildrenRef = useRef<any[]>([]);  //打开弹窗时该行特殊效率的原始 children（用于找回已填的效率值）

  useEffect(() =>
  {
    paramDatasRef.current = paramDatas;
  }, [paramDatas]);

  console.log('localFormDatalocalFormDatalocalFormData',localParamValues);

  //塔板数越界校验：改过塔板数后，起始/结束塔板、进料/出料位置的值不能大于塔板数
  useEffect(() =>
  {
      let newErrorInputs = [];
      if(trayRangeCheckRef.current && selectedElementData?.elementNodeType==="DistilStrict")
      {
          let paramList = paramDatasRef.current?.flatMap((classData)=>classData.params) ?? [];
          let trayCount = Number(paramList.find((param)=>param.engName==="N")?.value);
          if(!Number.isNaN(trayCount))
          {
              let trayRelatedParams =
              [
                  {engName:"eff",keys:["起始塔板","结束塔板"]},
                  {engName:"Ns",keys:["进料位置"]},
                  {engName:"No",keys:["出料位置"]},
              ];

              trayRelatedParams.forEach((trayParam)=>
              {
                  let targetParam = paramList.find((param)=>param.engName===trayParam.engName && param.children);
                  if(!targetParam)
                  {
                      return;
                  }
                  targetParam.children.forEach((child,index)=>
                  {
                      trayParam.keys.forEach((key)=>
                      {
                          let trayValue = child[key]?.value;
                          if(trayValue==="" || trayValue===null || trayValue===undefined)
                          {
                              return;
                          }
                          let trayNum = Number(trayValue);
                          //值大于塔板数的输入框标红，并阻止确认保存
                          if(!Number.isNaN(trayNum) && trayNum>trayCount)
                          {
                              newErrorInputs.push(`${trayParam.engName}_${index}_${key}`);
                          }
                      });
                  });
              });
          }
      }
      setErrorInputs((prev)=>(prev.length===0 && newErrorInputs.length===0) ? prev : newErrorInputs);
  }, [paramDatas]);

  //塔板数越界时输入框样式（红框略加粗+浅红底），便于识别
  const trayRangeErrorStyle = (errorKey,baseStyle) =>
  {
      if(!errorInputs.includes(errorKey))
      {
          return baseStyle;
      }
      return {...baseStyle,borderColor:"#FF4D4F",borderWidth:1.5,backgroundColor:"#FFF1F0"};
  };

  //切换所选元件/流股/分组时触发
  useEffect(() => 
  {
    setParamDatas(null);
    trayCountBaseRef.current = null;
    trayLinkedFieldsRef.current = [];
    trayRangeCheckRef.current = false;
    setErrorInputs([]);
    if(selectedElementData && localParamValues)
    {
        let dataSource = {nodeDataArray:null,linkDataArray:null};
        dataSource.nodeDataArray = diagramInstance.model.nodeDataArray;
        dataSource.linkDataArray = diagramInstance.model.linkDataArray;

        initializeFunc(dataSource);
    }
  }, [selectedElementData,localParamValues]);

  useEffect(() => 
  {
    if(errorInputs.length>0)
    {
      saveAbled(false);
    }
    else
    {
      saveAbled(true);
    }
  }, [errorInputs]);

  //初始化函数
  const initializeFunc = async(dataSource) =>
  {
      if(selectedElementData.elementType==="node")
      {
          //元件
          let nodeTypeParamsForm = await buildNodeTypeParamsForm();
          //特殊处理
          nodeTypeParamsForm["分离器"] = nodeTypeParamsForm["分流器"];
          let newExpandEffRow= [];

          let secondaryTypeName = selectedElementData.elementSecondaryTypeName;
          let originalParamDatas = nodeTypeParamsForm[secondaryTypeName];
          // 新拖入未保存的元件没有 ParamValues，兜底为空对象，避免取值报错
          let jsonParamDatas = selectedElementData.paramsData ?? {};

          //构建参数分类
          let paramsDataClasses = {"规定":[],"描述":[]};

          //基础参数特殊处理
          for (let basicFieldName in selectedElementData.basicData)
          {
            let basicData = 
            {
                name:basicFieldName,
                engName:selectedElementData.basicData[basicFieldName].engName,
                //计算模式不显示，提交时固定默认值 TP
                show:selectedElementData.basicData[basicFieldName].engName==="mode"?false:true,
                class:basicFieldName==="描述"?"描述":"规定",
                value:selectedElementData.basicData[basicFieldName].engName==="mode"?"TP":selectedElementData.basicData[basicFieldName].value,
                unitValue:null,
                unit:null,
                unitField:null,
                enum:selectedElementData.basicData[basicFieldName].enum??null,
                children:null,
            };
            paramsDataClasses[basicFieldName==="描述"?"描述":"规定"].push(basicData);
          }

          for (let engName in originalParamDatas)
          {
              let originalParamData = originalParamDatas[engName];

              let paramName = originalParamData.p_name;
              let paramClass = originalParamData.p_class ?? "规定";
              let paramUnit = originalParamData.p_unit ?? null;
              let paramEnum = originalParamData.enum ?? null;
              let paramUnitField = originalParamData.p_unitField ?? null;

              let jsonParamData = jsonParamDatas[paramName] ?? {};
              let paramShow = jsonParamData.show ?? originalParamData.p_show;
              let paramValue = jsonParamData.value ?? null;
              let paramUnitValue = jsonParamData.unit ?? null;
              let paramChildren = jsonParamData.p_children ?? null;
              // 特殊处理：分流器“输出流量”按当前输出流股显示；有输出流股但无已保存子项时按默认值生成
              // （最后一个输出流股留空，保证“有且仅有一个为空”），无输出流股时不显示
              if (engName === "output_f") {
                const outLinks = (dataSource.linkDataArray || []).filter(
                  (item: any) => item.from === selectedElementData.elementID,
                );
                if (outLinks.length > 0) {
                  if (!paramChildren || paramChildren.length === 0) {
                    const defaultF =
                      originalParamData.p_children?.find((item: any) => item.p_engName === "输出流量")?.p_value ?? null;
                    paramChildren = outLinks.map((link: any, index: number) => {
                      // 摩尔分率（frac）时所有流股都需要有值；其他单位最后一个输出流股留空（有且仅有一个为空）
                      const isFrac = localParamValues?.["输出流量单位"]?.value === "frac";
                      const initialF = !isFrac && index === outLinks.length - 1 ? "" : defaultF;
                      return {
                        流股: {
                          value: link.text || link.linkName || "",
                          desValue: link.text || link.linkName || "",
                          show: true,
                          engName: "streamName",
                          readonly: true,
                        },
                        输出流量: {
                          value: initialF,
                          desValue: initialF,
                          show: true,
                          engName: "输出流量",
                        },
                      };
                    });
                  }
                } else {
                  // 无输出流股：不显示“输出流量”
                  paramShow = false;
                }
              }

              //单位类型
              if(originalParamData.p_type)
              {
                  if(unitMap[originalParamData.p_type])
                  {
                      paramUnit = unitMap[originalParamData.p_type];
                  }
              }

              //修改单位枚举格式
              if(paramUnit)
              {
                  paramUnit = paramUnit.map(item => ({value:item,label:item}));
              }

              //特殊处理
              if(selectedElementData.elementNodeType==="DistilStrict" && (paramName==="进料流股位置"||paramName==="出料流股位置"||paramName==="塔板效率"))
              {
                  paramClass = paramName;

                  if(paramName==="进料流股位置")
                  {
                    if(localParamValues[paramName])
                    {
                      paramChildren = localParamValues[paramName].p_children;
                    }
                  }
                  else if(paramName==="出料流股位置")
                  {
                    if(localParamValues[paramName])
                    {
                      paramChildren = localParamValues[paramName].p_children;
                    }
                  }
                  else if(paramName==="塔板效率")
                  {
                    //定义特殊效率空数组
                    let emptySpecDatas = [];
                    // for(let i=0;i<globalData.materials.length;i++)
                    // {
                    //   let emptySpecData = 
                    //   {
                    //     组分:
                    //     {
                    //       value:globalData.materials[i].name,
                    //       show:true,
                    //       engName:"组分",
                    //       readonly:true},
                    //     效率值:
                    //     {
                    //       value:"",
                    //       desValue:"",
                    //       show:true,
                    //       engName:"效率值"
                    //     }
                    //   };
                    //   emptySpecDatas.push(emptySpecData);
                    // }

                    if(!paramChildren)
                    {
                      paramChildren = [];
                    }

                    for(let i=0;i<paramChildren.length;i++)
                    {
                      // debugger
                      if(paramChildren[i]["特殊效率"])
                      {
                        if(paramChildren[i]["特殊效率"].children.length===0)
                        {
                          paramChildren[i]["特殊效率"].children = emptySpecDatas;
                        }
                        else
                        {
                          newExpandEffRow.push(i);
                          // paramChildren[i]["特殊效率"].children.map((c,ind)=>{
                          //   const zfname=c['组分'].value;
                          //   const idx=globalData.materials.findIndex((gi)=>gi.name===zfname)+1;
                          //   paramChildren[i]["特殊效率"].children[ind]['组分'].idx=idx
                          // })
                          
                        }
                      }
                      else 
                      {
                        paramChildren[i]["特殊效率"] = emptySpecDatas;
                      }
                    }

                    
                  }

              }
              if(selectedElementData.elementNodeType==="Splitter" && (paramName==="输出流量"))
              {
                  paramClass = paramName;
                  if(localParamValues[paramName])
                  {
                    paramChildren = localParamValues[paramName].p_children;
                  }
              }
              if(selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && (paramName==="冷流股出口温度"||paramName==="冷流股出口压力"||paramName==="热流股出口温度"||paramName==="热流股出口压力"||paramName==="出入流股关系"))
              {
                  paramClass = paramName;
                  if(paramName==="出入流股关系")
                  {
                    if(localParamValues[paramName])
                    {
                      paramChildren = localParamValues[paramName].p_children;
                    }
                  }
              }
              if(selectedElementData.elementNodeType==="DistilStrict" && (paramName==="内部类型" || paramName==="是否使用Murphree效率"||paramName==="设备描述"))
              {
                  paramShow = false;
              }
              if(selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramName==="流股属性")
              {
                  paramShow = false;
              }
              if(selectedElementData.elementNodeType==="ShellAndTubeExchanger" && (paramName==="冷流出口温度"||paramName==="冷流出口压力"||paramName==="热流出口温度"||paramName==="热流出口压力"))
              {
                if(jsonParamDatas["流股属性"])
                {
                  let streamAttribute  = jsonParamDatas["流股属性"].value;
                  if(streamAttribute==="冷流股")
                  {
                    if(paramName==="热流出口温度"||paramName==="热流出口压力")
                    {
                      paramShow = false;
                    }
                  }
                  else if(streamAttribute==="热流股")
                  {
                    if(paramName==="冷流出口温度"||paramName==="冷流出口压力")
                    {
                      paramShow = false;
                    }
                  }
                }
              }

              let paramData = 
              {
                  name:paramName,
                  engName:engName,
                  show:paramShow,
                  class:paramClass,
                  value:paramValue,
                  unitValue:paramUnitValue,
                  unit:paramUnit,
                  unitField:paramUnitField,
                  enum:paramEnum,
                  children:paramChildren,
              }

              if(paramsDataClasses[paramClass])
              {
                  paramsDataClasses[paramClass].push(paramData);
              }
              else
              {
                  paramsDataClasses[paramClass] = [];
                  paramsDataClasses[paramClass].push(paramData);
              }
          }

          //将paramsDataClasses改为数组并排序
          let newParamDatas = [];
          for (let className in paramsDataClasses)
          {
              //操作参数、几何参数、设计工况、设计裕量、壁面条件 这几个部分不要了，直接过滤不显示
              if(["操作参数","几何参数","设计工况","设计裕量","壁面条件"].includes(className))
              {
                  continue;
              }
              let classData = 
              {
                  className:className,
                  params:paramsDataClasses[className],
              };
              newParamDatas.push(classData);
          }

          //排序
          if(selectedElementData.elementNodeType==="DistilStrict")
          {
              let classOrder = 
              [
                  "规定",
                  "塔板效率",
                  "进料流股位置",
                  "出料流股位置",
                  "塔内件参数",
                  "填料参数",
                  "水力参数",
                  //"操作参数",
                  //"几何参数",
                  //"设计工况",
                  //"设计裕量",
                  //"壁面条件",
                  "工艺名称",
                  "收敛选项",
                  "描述",
              ];
              newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));
          }
          else if(selectedElementData.elementNodeType==="Splitter")
          {
              let classOrder = 
              [
                  "规定",
                  "输出流量",
                  "描述",
              ];
              newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));
          }
          else if(selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4")
          {
              let classOrder = 
              [
                  "规定",
                  "出入流股关系",
                  "冷流股出口温度",
                  "冷流股出口压力",
                  "热流股出口温度",
                  "热流股出口压力",
                  "描述",
              ];
              newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));
          }
          else
          {
              let classOrder = 
              [
                  "规定",
                  "描述",
              ];
              newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));
          }

          //查询关联流股
          let newRelateElements = await queryRelateElement(selectedElementData,dataSource);
          console.log('newParamDatasnewParamDatasnewParamDatas',newParamDatas);
          setParamDatas(newParamDatas);
          setRelateElements(newRelateElements);

          //展开效率行
          // debugger
          setExpandEffRow(newExpandEffRow);

          //塔更新内部类型
          if(selectedElementData.elementType==="node" && selectedElementData.elementNodeType==="DistilStrict")
          {
            let internalTypeValue = selectedElementData.paramsData?.["内部类型"].value??null;
            setTimeout(() => {
              if(internalTypeValue)
              {
                upParamData("internalType",{value:internalTypeValue},true);
              }
            }, 100);
          } 
      }
      else if(selectedElementData.elementType==="link")
      {
          //流股
          let nodeTypeParamsForm = await buildNodeTypeParamsForm();
          let secondaryTypeName = "link";
          let originalParamDatas = nodeTypeParamsForm[secondaryTypeName];
          // 新绘制未保存的流股没有 ParamValues，兜底为空对象，避免取值报错
          let jsonParamDatas = selectedElementData.paramsData ?? {};
          let materialsDatas = selectedElementData.materialsData;
          // 新绘制未保存的流股没有 materials 属性，默认生成全组分列表（组分齐全、值为空）
          if (!materialsDatas || typeof materialsDatas !== "object" || Object.keys(materialsDatas).length === 0) {
            materialsDatas = {};
            (globalData?.materials || []).forEach((material: any) => {
              materialsDatas[material.formula] = {
                molar_frac: "",
                desValue: "",
                cas: material.cas_code,
                name: material.formula,
                chineseName: material.name,
              };
            });
          }

          //构建参数分类
          let paramsDataClasses = {"规定":[],"描述":[],"组分":[]};

          //基础参数特殊处理
          for (let basicFieldName in selectedElementData.basicData)
          {
            let basicData = 
            {
                name:basicFieldName,
                engName:selectedElementData.basicData[basicFieldName].engName,
                show:true,
                class:basicFieldName==="描述"?"描述":"规定",
                value:selectedElementData.basicData[basicFieldName].value,
                unitValue:null,
                unit:null,
                unitField:null,
                enum:selectedElementData.basicData[basicFieldName].enum??null,
                children:null,
            };
            paramsDataClasses[basicFieldName==="描述"?"描述":"规定"].push(basicData);
          }

          for (let engName in originalParamDatas)
          {
              let originalParamData = originalParamDatas[engName];

              let paramName = originalParamData.p_name;
              let paramClass = originalParamData.p_class ?? "规定";
              let paramUnit = originalParamData.p_unit ?? null;
              let paramUnitField = originalParamData.p_unitField ?? null;
              let paramEnum = originalParamData.enum ?? null;
              let paramShow = originalParamData.p_show;

              let jsonParamData = jsonParamDatas[paramName] ?? {};
              let paramValue = jsonParamData.value ?? null;
              let paramUnitValue = jsonParamData.unit ?? null;
              let paramChildren = jsonParamData.p_children ?? null;

              //单位类型
              if(originalParamData.p_type)
              {
                  if(unitMap[originalParamData.p_type])
                  {
                      paramUnit = unitMap[originalParamData.p_type];
                  }
              }

              //修改单位枚举格式
              if(paramUnit)
              {
                  paramUnit = paramUnit.map(item => ({value:item,label:item}));
              }

              let paramData = 
              {
                  name:paramName,
                  engName:engName,
                  show:paramShow,
                  class:paramClass,
                  value:paramValue,
                  unitValue:paramUnitValue,
                  unit:paramUnit,
                  unitField:paramUnitField,
                  enum:paramEnum,
                  children:paramChildren,
              }

              if(paramsDataClasses[paramClass])
              {
                  paramsDataClasses[paramClass].push(paramData);
              }
              else
              {
                  paramsDataClasses[paramClass] = [];
                  paramsDataClasses[paramClass].push(paramData);
              }
          }

          //组分特殊处理
          for (let materialName in materialsDatas)
          {
              let materialsData = materialsDatas[materialName];
              let paramData = 
              {
                  name:materialsData.chineseName,
                  engName:materialName,
                  show:true,
                  class:"组分",
                  value:materialsData.molar_frac,
                  unitValue:null,
                  unit:null,
                  unitField:null,
                  enum:null,
                  children:null,
              };
              paramsDataClasses["组分"].push(paramData);
          }

          //将paramsDataClasses改为数组并排序
          let newParamDatas = [];
          for (let className in paramsDataClasses)
          {
              let classData = 
              {
                  className:className,
                  params:paramsDataClasses[className],
              };
              newParamDatas.push(classData);
          }
          //排序
          let classOrder = 
          [
              "规定",
              "描述",
              "组分",
          ];
          newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));
          
          //查询关联元件
          let newRelateElements = await queryRelateElement(selectedElementData,dataSource);

          setParamDatas(newParamDatas);
          setRelateElements(newRelateElements);
      }
      else if(selectedElementData.elementType==="group")
      {
          //分组

          //构建参数分类
          let paramsDataClasses = {"描述":[]};

          //描述特殊处理
          let descriptionData = 
          {
              name:"描述",
              engName:"description",
              show:true,
              class:"描述",
              value:selectedElementData.basicData["描述"].value,
              unitValue:null,
              unit:null,
              unitField:null,
              enum:null,
              children:null,
          };
          paramsDataClasses["描述"].push(descriptionData);

          //将paramsDataClasses改为数组并排序
          let newParamDatas = [];
          for (let className in paramsDataClasses)
          {
              let classData = 
              {
                  className:className,
                  params:paramsDataClasses[className],
              };
              newParamDatas.push(classData);
          }
          //排序
          let classOrder = 
          [
              "描述",
          ];
          newParamDatas.sort((a,b) => (classOrder.indexOf(a.className) + 1 || classOrder.length + 1) - (classOrder.indexOf(b.className) + 1 || classOrder.length + 1));

          //查询关联元件/流股
          let newRelateElements = await queryRelateElement(selectedElementData,dataSource);

          setParamDatas(newParamDatas);
          setRelateElements(newRelateElements);
      }

      //初始化完成
      setInitializeVariable(true);
  };

  //塔板数联动：把塔板相关参数中值等于原塔板数的字段，一起改成新塔板数
  //（塔板效率的起始/结束塔板、进料流股位置、出料流股位置）
  const updateTrayRelatedByTrayCount = (newValue) =>
  {
      let newNum = Number(newValue);
      //输入框被清空或输入非数字时不联动
      if(newValue==="" || newValue===null || newValue===undefined || Number.isNaN(newNum))
      {
          return;
      }

      let paramList = paramDatasRef.current?.flatMap((classData)=>classData.params) ?? [];

      //基准值固定为进入塔板数输入框时的原塔板数，避免逐字符输入时把中间值当成原塔板数
      let baseNum = trayCountBaseRef.current;
      if(baseNum===null)
      {
          baseNum = Number(paramList.find((param)=>param.engName==="N")?.value);
      }
      if(Number.isNaN(baseNum))
      {
          return;
      }

      let linkedFields = trayLinkedFieldsRef.current;
      //需要联动的参数及其位置字段
      let trayRelatedParams =
      [
          {engName:"eff",keys:["起始塔板","结束塔板"]},
          {engName:"Ns",keys:["进料位置"]},
          {engName:"No",keys:["出料位置"]},
      ];

      trayRelatedParams.forEach((trayParam)=>
      {
          let targetParam = paramList.find((param)=>param.engName===trayParam.engName && param.children);
          if(!targetParam)
          {
              return;
          }

          let changed = false;
          let newChildren = targetParam.children.map((child,index)=>
          {
              let newChild = {...child};
              let hit = false;
              trayParam.keys.forEach((key)=>
              {
                  let trayValue = child[key]?.value;
                  //已联动的字段继续跟随；其余只处理值等于原塔板数的字段
                  let isLinked = linkedFields.some((field)=>field.engName===trayParam.engName && field.index===index && field.key===key);
                  let isBaseValue = trayValue!=="" && trayValue!==null && trayValue!==undefined && Number(trayValue)===baseNum;
                  if(!isLinked && !isBaseValue)
                  {
                      return;
                  }
                  if(!isLinked)
                  {
                      linkedFields.push({engName:trayParam.engName,index:index,key:key});
                  }
                  if(String(trayValue)===String(newValue))
                  {
                      return;
                  }
                  newChild[key] = {...child[key],value:newValue};
                  hit = true;
              });
              if(!hit)
              {
                  return child;
              }
              changed = true;
              return newChild;
          });
          if(changed)
          {
              upParamData(trayParam.engName,{children:newChildren});
          }
      });
  };

  //组件修改参数值
  const upParamData = async(engName,updates,isSpec?) =>
  {
      //塔板数变化时，联动修改塔板效率的起始/结束塔板、进料/出料位置，并开启越界校验
      if(engName==="N" && updates.value!==undefined && selectedElementData?.elementNodeType==="DistilStrict")
      {
          trayRangeCheckRef.current = true;
          updateTrayRelatedByTrayCount(updates.value);
      }

      setParamDatas((prev) =>prev?.map((classData) => 
          ({
              ...classData,
              params:classData.params.map((param) =>
                  param.engName === engName ? { ...param,...updates} : param
              ),
          }))
      );

      //特殊处理
      if(isSpec)
      {
          upSpecParamData(engName,updates);
      }
  };

  //组件修改参数值时的特殊处理
  const upSpecParamData = async(engName,updates) =>
  {
      //内部类型
      if(engName==="internalType" && selectedElementData.elementNodeType==="DistilStrict")
      {
          if(updates.value==="塔板")
          {
              await upParamData("trayType",{show:true});
              await upParamData("N",{show:true});
              await upParamData("theta",{show:true});
              await upParamData("h_w",{show:true});
              await upParamData("tray_material",{show:true});
              await upParamData("overflow_type",{show:true});
              await upParamData("packingType",{show:false});
              await upParamData("packing_total_height",{show:false});
          }
          else if(updates.value==="填料")
          {
              await upParamData("trayType",{show:false});
              await upParamData("theta",{show:false});
              await upParamData("h_w",{show:false});
              await upParamData("tray_material",{show:false});
              await upParamData("overflow_type",{show:false});
              await upParamData("packingType",{show:true});
              await upParamData("packing_total_height",{show:true});
          }
          else if(updates.value==="混合")
          {
              await upParamData("trayType",{show:true});
              await upParamData("N",{show:true});
              await upParamData("theta",{show:true});
              await upParamData("h_w",{show:true});
              await upParamData("tray_material",{show:true});
              await upParamData("overflow_type",{show:true});
              await upParamData("packingType",{show:true});
              await upParamData("packing_total_height",{show:true});
          }
      }
      //操作规范
      else if(engName==="operatingSpecifications" && selectedElementData.elementNodeType==="DistilStrict" && selectedElementData.elementSecondaryTypeName==="汽提塔")
      {
          if(updates.value==="塔底物流率")
          {
              await upParamData("operatingSpecificationsValue",{unitValue:"kmol/hr",unit:[{value:"kmol/hr",label:"kmol/hr"},{value:"kg/hr",label:"kg/hr"},{value:"cum/hr",label:"cum/hr"}]});
          }
          else if(updates.value==="再沸器负荷")
          {
              await upParamData("operatingSpecificationsValue",{unitValue:"Gcal/hr",unit:[{value:"Gcal/hr",label:"Gcal/hr"},{value:"kW",label:"kW"}]});
          }
      }
      // //流股属性(多流股换热器)
      // else if(engName==="streamAttribute" && selectedElementData.elementType==="node" && selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4")
      // {
      //     if(updates.value==="冷流股")
      //     {
      //         await upParamData("cold_out_T",{show:true});
      //         await upParamData("cold_out_P",{show:true});
      //         await upParamData("hot_out_T",{show:false});
      //         await upParamData("hot_out_P",{show:false});
      //     }
      //     else if(updates.value==="热流股")
      //     {
      //         await upParamData("cold_out_T",{show:false});
      //         await upParamData("cold_out_P",{show:false});
      //         await upParamData("hot_out_T",{show:true});
      //         await upParamData("hot_out_P",{show:true});
      //     }
      // }
      //流股属性(换热器)
      else if(engName==="streamAttribute" && selectedElementData.elementType==="node" && selectedElementData.elementNodeType==="ShellAndTubeExchanger")
      {

          if(updates.value==="冷流股")
          {
              await upParamData("cold_out_T",{show:true});
              await upParamData("cold_out_P",{show:true});
              await upParamData("hot_out_T",{show:false});
              await upParamData("hot_out_P",{show:false});
          }
          else if(updates.value==="热流股")
          {
              await upParamData("cold_out_T",{show:false});
              await upParamData("cold_out_P",{show:false});
              await upParamData("hot_out_T",{show:true});
              await upParamData("hot_out_P",{show:true});
          }
      }
      else if(engName==="mode" && selectedElementData.elementNodeType==="Flash2")
      {
          if(updates.value==="TP")
          {
              await upParamData("t",{show:true});
              await upParamData("vaporFraction",{show:false});
          }
          else if(updates.value==="VP" || updates.value==="HP")
          {
              await upParamData("t",{show:false});
              await upParamData("vaporFraction",{show:true});
          }
      }

      //单位
      if(updates.unitValue)
      {
          let nodeTypeParamsForm = await buildNodeTypeParamsForm();
          if(selectedElementData.elementType==="node")
          {
              let params = nodeTypeParamsForm[selectedElementData.elementSecondaryTypeName];
              if(params && params[engName])
              {
                  let unitField = params[engName].p_unitField;
                  if(unitField)
                  {
                      //寻找与其unitField相同的参数
                      let upUnitValueParams = Object.values(params).filter(item=>item["p_unitField"]===unitField && item["p_engName"]!==engName)
                      for(let i=0;i<upUnitValueParams.length;i++)
                      {
                          await upParamData(upUnitValueParams[i]["p_engName"],{unitValue:updates.unitValue});
                      }
                  }
              }
          }
          else if(selectedElementData.elementType==="link")
          {

          }
          else if(selectedElementData.elementType==="group")
          {

          }
      }
  };

  //粘贴组分
  const copyMaterialsData = async() =>
  {
      let copyMaterialsDatas = copyMaterialsDataTxt.split('\n');
      copyMaterialsDatas = copyMaterialsDatas.filter(item=>item!=="");
      let materialsClass = paramDatas.find(item=>item.className==="组分");
      if(materialsClass)
      {
          let materialsParams = materialsClass.params;

          for(let i=0;i<materialsParams.length;i++)
          {
              let engName = materialsParams[i].engName;
              if(copyMaterialsDatas[i])
              {
                  await upParamData(engName,{value:copyMaterialsDatas[i]});
              }
              else
              {
                  break;
              }
          }
      }
      else
      {
          return false;
      }

      return true;
  };

  //将新的参数格式转化为旧的(用于保存)
  const upOldParams = async() =>
  {
    let newLocalFormData = structuredClone(localFormData);
    let newLocalParamValues = structuredClone(localParamValues);
    let newLocalMaterialsData = structuredClone(localMaterialsData);
    let newParamDatas = structuredClone(paramDatasRef.current);

    let allParamDatas = [];
    for(let i=0;i<newParamDatas.length;i++)
    {
      let classParamDatas = newParamDatas[i];
      for(let j=0;j<classParamDatas.params.length;j++)
      {
        let classParamData = classParamDatas.params[j];

        //特殊处理
        if(classParamData.engName==="internalType")
        {
          classParamData.show = true;
        }

        allParamDatas.push(classParamData);
      }
    }

    //基础参数
    for (let fieldName in newLocalFormData)
    {
      let paramData = allParamDatas.find(item=>item.name===fieldName);
      if(paramData)
      {
        newLocalFormData[fieldName].show = paramData.show;

        if("value" in newLocalFormData[fieldName])
        {
          newLocalFormData[fieldName].value = paramData.value;
        }
        if("unit" in newLocalFormData[fieldName])
        {
          newLocalFormData[fieldName].unit = paramData.unitValue;
        }
        if("p_children" in newLocalFormData[fieldName])
        {
          newLocalFormData[fieldName].p_children = paramData.children;
        }
      }
    }

    //参数
    for (let fieldName in newLocalParamValues)
    {
      let paramData = allParamDatas.find(item=>item.name===fieldName);
      if(paramData)
      {
        newLocalParamValues[fieldName].show = paramData.show;

        if("value" in newLocalParamValues[fieldName])
        {
          if(paramData.value==="")
          {
            paramData.value = null;
          }
          newLocalParamValues[fieldName].value = paramData.value;
        }
        if("unit" in newLocalParamValues[fieldName])
        {
          newLocalParamValues[fieldName].unit = paramData.unitValue;
        }
        if("p_children" in newLocalParamValues[fieldName])
        {
          newLocalParamValues[fieldName].p_children = paramData.children;
        }
      }
    }

    //组分
    for (let fieldName in newLocalMaterialsData)
    {
      let paramData = allParamDatas.find(item=>item.engName===fieldName);
      if(paramData)
      {
        if("molar_frac" in newLocalMaterialsData[fieldName])
        {
          newLocalMaterialsData[fieldName].molar_frac = paramData.value;
        }
      }
    }

    setLocalFormData(newLocalFormData);
    setLocalParamValues(newLocalParamValues);
    setLocalMaterialsData(newLocalMaterialsData);

    let oldParams = {localFormData:newLocalFormData,localParamValues:newLocalParamValues,localMaterialsData:newLocalMaterialsData}
    return oldParams;
  };

  if(initializeVariable && selectedElementData)
  {
    return (
      <div style={{display:"flex",flexDirection: "column",height:"100%"}}>
        {contextHolder}

        <div style={{display: "flex",flexDirection: "row",width:"100%",minHeight:70,maxHeight:70,borderBottom:"1px solid #BBB",}}>
          <div style={{display:"flex",alignItems:"center",minWidth:100,height:"100%",fontSize:18,fontWeight:"bold",color:"#5F5F5F",marginLeft:20}}>
            {`${selectedElementData.elementName}：`}
            </div>
            {/* 下拉的关联流股和关联元件的下拉选择框 */}
             {/* {selectedElementData.elementType==="node"||selectedElementData.elementType==="link"?(
            <div style={{display:"flex",alignItems:"center",width:120}}>
                {selectedElementData.elementType==="node"?(
                    <Select
                        value={"关联流股"}
                        onChange={async(val,e) => 
                        {
                            let element = relateElements.allLinks.find(item=>item.key===val);
                            if(element)
                            {
                                changeOtherElement(element);
                            }
                        }}
                        options={[
                            {
                                label:<span>进料流股</span>,
                                title:"进料流股",
                                options:relateElements.inLinks.map(({name,key})=>({label:name,value:key})),
                            },
                            {
                                label:<span>出料流股</span>,
                                title:"出料流股",
                                options:relateElements.outLinks.map(({name,key})=>({label:name,value:key})),
                            },
                        ]}
                        style={{flex:1}}
                        getPopupContainer={(trigger) => trigger.parentNode}
                    />
                ):null}
                {selectedElementData.elementType==="link"?(
                    <Select
                        value={"关联设备"}
                        onChange={async(val,e) => 
                        {
                            let element = relateElements.allNodes.find(item=>item.key===val);
                            if(element)
                            {
                                changeOtherElement(element);
                            }
                        }}
                        options={[
                            {
                                label:<span>来源设备</span>,
                                title:"来源设备",
                                options:relateElements.fromNodes.map(({name,key})=>({label:name,value:key})),
                            },
                            {
                                label:<span>流向设备</span>,
                                title:"流向设备",
                                options:relateElements.toNodes.map(({name,key})=>({label:name,value:key})),
                            },
                        ]}
                        style={{flex:1}}
                        getPopupContainer={(trigger) => trigger.parentNode}
                    />
                ):null}
            </div>
        ):null} */}

        </div>

        <div style={{display:"flex",flexDirection: "column",flex:1,backgroundColor:"transparent",marginLeft:20,marginRight:20,marginBottom:15,overflowY: "auto",overflowX:"hidden"}}>

           

            {/* 特殊处理:关联流股/关联设备 横向展开列出 */}
            {(selectedElementData.elementType==="node"||selectedElementData.elementType==="link")?(
                <div style={{display:"flex",flexDirection:"row",alignItems:"center",flexWrap:"wrap",width:"100%",minHeight:35,marginLeft:10,marginTop:10,fontSize:16,fontWeight:"bold",color:"#1b6ae7"}}>
                    {selectedElementData.elementType==="node"?(
                        <>
                            <span style={{marginRight:8}}>关联流股：</span>
                            <span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#5F5F5F"}}>进料：</span>
                            {relateElements.inLinks.length>0?(
                                relateElements.inLinks.map(({name,key})=>(
                                    <span
                                        key={key}
                                        onClick={() => { const element = relateElements.allLinks.find(item=>item.key===key); if(element){ changeOtherElement(element); } }}
                                        style={{cursor:"pointer",marginRight:6,marginBottom:4,fontSize:14,fontWeight:"normal",color:"#165DFF",background:"#e6f7ff",padding:"2px 8px",borderRadius:4}}
                                    >{name}</span>
                                ))
                            ):<span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#999"}}>无</span>}
                            <span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#5F5F5F"}}>出料：</span>
                            {relateElements.outLinks.length>0?(
                                relateElements.outLinks.map(({name,key})=>(
                                    <span
                                        key={key}
                                        onClick={() => { const element = relateElements.allLinks.find(item=>item.key===key); if(element){ changeOtherElement(element); } }}
                                        style={{cursor:"pointer",marginRight:6,marginBottom:4,fontSize:14,fontWeight:"normal",color:"#165DFF",background:"#e6f7ff",padding:"2px 8px",borderRadius:4}}
                                    >{name}</span>
                                ))
                            ):<span style={{fontSize:14,fontWeight:"normal",color:"#999"}}>无</span>}
                        </>
                    ):null}
                    {selectedElementData.elementType==="link"?(
                        <>
                            <span style={{marginRight:8}}>关联设备：</span>
                            <span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#5F5F5F"}}>来源：</span>
                            {relateElements.fromNodes.length>0?(
                                relateElements.fromNodes.map(({name,key})=>(
                                    <span
                                        key={key}
                                        onClick={() => { const element = relateElements.allNodes.find(item=>item.key===key); if(element){ changeOtherElement(element); } }}
                                        style={{cursor:"pointer",marginRight:6,marginBottom:4,fontSize:14,fontWeight:"normal",color:"#165DFF",background:"#e6f7ff",padding:"2px 8px",borderRadius:4}}
                                    >{name}</span>
                                ))
                            ):<span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#999"}}>无</span>}
                            <span style={{marginRight:6,fontSize:14,fontWeight:"normal",color:"#5F5F5F"}}>流向：</span>
                            {relateElements.toNodes.length>0?(
                                relateElements.toNodes.map(({name,key})=>(
                                    <span
                                        key={key}
                                        onClick={() => { const element = relateElements.allNodes.find(item=>item.key===key); if(element){ changeOtherElement(element); } }}
                                        style={{cursor:"pointer",marginRight:6,marginBottom:4,fontSize:14,fontWeight:"normal",color:"#165DFF",background:"#e6f7ff",padding:"2px 8px",borderRadius:4}}
                                    >{name}</span>
                                ))
                            ):<span style={{fontSize:14,fontWeight:"normal",color:"#999"}}>无</span>}
                        </>
                    ):null}
                </div>
            ):null}

            {/* 特殊处理:塔的内部类型单独展示 */}
            {selectedElementData.elementNodeType==="DistilStrict"&& paramDatas && paramDatas.find(item=>item.className==="规定")?.params.find(item=>item.engName==="internalType")?(
                <div style={{display:"flex",flexDirection:"row",alignItems:"center",flex:1,minHeight:35,maxHeight:35,marginLeft:10,marginTop:10,fontSize:16,fontWeight:"bold",color:"#1b6ae7"}}>
                    内部类型：
                    <Radio.Group
                        value={paramDatas.find(item=>item.className==="规定").params.find(item=>item.engName==="internalType").value}
                        onChange={(e) => upParamData("internalType",{value:e.target.value},true)}
                        style={{marginLeft:10,fontSize:14,color:"#5F5F5F",fontWeight:"normal"}}
                        options={paramDatas.find(item=>item.className==="规定").params.find(item=>item.engName==="internalType").enum.map(item => ({label:item.label,value:item.value }))}
                    />
                </div>
            ):null}

            {/* 特殊处理:塔的是否使用Murphree效率单独展示 */}
            {selectedElementData.elementNodeType==="DistilStrict"&& paramDatas && paramDatas.find(item=>item.className==="规定")?.params.find(item=>item.engName==="internalType")?(
                <div style={{display:"flex",flexDirection:"row",alignItems:"center",flex:1,minHeight:35,maxHeight:35,marginLeft:10,marginTop:10,fontSize:16,fontWeight:"bold",color:"#1b6ae7"}}>
                    是否使用Murphree效率:
                    <Radio.Group
                        value={paramDatas.find(item=>item.className==="规定").params.find(item=>item.engName==="murphree").value}
                        onChange={(e) => upParamData("murphree",{value:e.target.value},true)}
                        style={{marginLeft:10,fontSize:14,color:"#5F5F5F",fontWeight:"normal"}}
                        options={paramDatas.find(item=>item.className==="规定").params.find(item=>item.engName==="murphree").enum.map(item => ({label:item.label,value:item.value }))}
                    />
                </div>
            ):null}

            <div style={{display: "flex",flexWrap:"wrap",alignContent: "flex-start",flex:1}}>
                {paramDatas && paramDatas.map((classData) => (
                    <div key={classData.className} style={{display:classData.params.filter(item=>item.show===true).length>0?"flex":"none",flex: "0 0 calc(50% - 20px)",flexDirection:"column",border:"1px solid #BBB",borderRadius:5,padding:20,margin:10}}>
                        <div style={{display: "flex",flexDirection: "row",width:"100%",fontSize:16,fontWeight:"bold",color:"#1b6ae7",marginBottom:15}}>
                            {classData.className}
                            {/* 特殊处理:塔板效率添加按钮 */}
                            {selectedElementData.elementNodeType==="DistilStrict" && classData.className==="塔板效率" ?(
                                <button
                                    onClick={()=>{
                                        let newParams = structuredClone(classData.params.find(item=>item.engName==="eff"));
                                        if(newParams)
                                        {
                                            //定义特殊效率空数组
                                            let emptySpecDatas = [];
                                            // for(let i=0;i<globalData.materials.length;i++)
                                            // {
                                            //   let emptySpecData = 
                                            //   {
                                            //     组分:
                                            //     {
                                            //       value:globalData.materials[i].name,
                                            //       show:true,
                                            //       engName:"组分",
                                            //       readonly:true},
                                            //     效率值:
                                            //     {
                                            //       value:"",
                                            //       desValue:"",
                                            //       show:true,
                                            //       engName:"效率值"
                                            //     }
                                            //   };
                                            //   emptySpecDatas.push(emptySpecData);
                                            // }

                                            let newChildren = newParams.children;
                                            let newChild = 
                                            {
                                                "起始塔板":{value:null,desValue:null,show: true,engName:"start"},
                                                "结束塔板":{value:null,desValue:null,show:true,engName:"end"},
                                                "效率值": {value:null,desValue:null,show:true,engName:"value"},
                                                "特殊效率": {value:[],desValue:[],show:false,engName:"spec",children:emptySpecDatas},
                                            };
                                            newChildren.push(newChild);
                                            upParamData("eff",{children:newChildren})
                                        }
                                    }}
                                    title="添加"
                                    style={{marginLeft:"auto",marginRight:"15px",width:30,height:"100%",fontSize:16,color:"#1b6ae7",border:0,backgroundColor:"transparent"}}
                                >
                                    <PlusCircleOutlined/>
                                </button>
                            ):null}
                            {/* 特殊处理:组分添加按钮 */}
                            {selectedElementData.elementType==="link" && classData.className==="组分" ?(
                                <button
                                    onClick={()=>{setModalVariable(true);}}
                                    title="粘贴组分"
                                    style={{marginLeft:"auto",marginRight:"15px",width:30,height:"100%",fontSize:16,color:"#1b6ae7",border:0,backgroundColor:"transparent"}}
                                >
                                    <CopyOutlined/>
                                </button>
                            ):null}
                        </div>

                        <div style={{display: "flex",flexWrap:"wrap",alignContent:"flex-start",flex:1,rowGap: "15px",columnGap:"20px"}}>
                            {classData.params && classData.params.map((paramData) => (
                                <div key={paramData.name} style={{display:paramData.show?"flex":"none",flex:!(paramData.children)&&(paramData.name!=="描述")?"0 0 calc(50% - 10px)":1,height:!(paramData.children)&&(paramData.name!=="描述")?35:(paramData.name==="描述"?100:"100%"),flexDirection:"row",border:"0px solid #BBB",borderRadius:5}}>

                                    {/* 子项目 */}
                                    {paramData.children?(
                                        <div style={{display:"flex",flexDirection:"row",flex:1}}>

                                            {/* 进料流股位置 */}
                                            {selectedElementData.elementNodeType==="DistilStrict" && paramData.engName==="Ns"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child,index) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 40px)/3)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["进料位置"].value}
                                                                  status={errorInputs.includes(`Ns_${index}_进料位置`)?"error":""}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"进料位置":{...item["进料位置"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={trayRangeErrorStyle(`Ns_${index}_进料位置`,{flex:1,fontSize:14})}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 出料流股位置 */}
                                            {selectedElementData.elementNodeType==="DistilStrict" && paramData.engName==="No"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child,index) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 40px)/3)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["出料位置"].value}
                                                                  status={errorInputs.includes(`No_${index}_出料位置`)?"error":""}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"出料位置":{...item["出料位置"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={trayRangeErrorStyle(`No_${index}_出料位置`,{flex:1,fontSize:14})}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 塔板效率 */}
                                            {selectedElementData.elementNodeType==="DistilStrict" && paramData.engName==="eff"?(
                                                <div style={{display:"flex",flexDirection:"column",flex:1}}>
                                                    <div style={{display:"flex",flexDirection:"row",height:35}}>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",border:"1px solid #BBB"}}>起始塔板</div>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",borderWidth: "1px 1px 1px 0",borderStyle:"solid",borderColor:"#BBB"}}>结束塔板</div>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",borderWidth: "1px 1px 1px 0",borderStyle:"solid",borderColor:"#BBB"}}>塔板效率</div>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:2,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",borderWidth: "1px 1px 1px 0",borderStyle:"solid",borderColor:"#BBB"}}>塔板组分效率</div>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:60,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",borderWidth: "1px 1px 1px 0",borderStyle:"solid",borderColor:"#BBB"}}>操作</div>        
                                                    </div>
                                                    {paramData.children.map((child,index) => (
                                                        <div style={{display:"flex",flexDirection:"row",minHeight:35,height:expandEffRow.includes(index) ? "auto" : 35,maxHeight:expandEffRow.includes(index) ? "none" : 35,flex:expandEffRow.includes(index) ? "0 0 auto" : 1}}>
                                                            <Input
                                                                value={child["起始塔板"].value}
                                                                onChange={(e) => {
                                                                    let newChildren = paramData.children.map(item =>item === child ? {...item,"起始塔板":{...item["起始塔板"],value:e.target.value}}:item);
                                                                    upParamData(paramData.engName,{children:newChildren})}}
                                                                style={trayRangeErrorStyle(`eff_${index}_起始塔板`,{textAlign: "center",flex:1,minWidth:0,padding:0,height:expandEffRow.includes(index) ? "100%" : 35,fontSize:14,color:"#5F5F5F",backgroundColor:"#FFF",borderWidth: "0 1px 1px 1px",borderStyle:"solid",borderColor:"#BBB",borderRadius:0})}
                                                            />
                                                            <Input
                                                                value={child["结束塔板"].value}
                                                                onChange={(e) => {
                                                                    let newChildren = paramData.children.map(item =>item === child ? {...item,"结束塔板":{...item["结束塔板"],value:e.target.value}}:item);
                                                                    upParamData(paramData.engName,{children:newChildren})}}
                                                                style={trayRangeErrorStyle(`eff_${index}_结束塔板`,{textAlign: "center",flex:1,minWidth:0,padding:0,height:expandEffRow.includes(index)? "100%" : 35,fontSize:14,color:"#5F5F5F",backgroundColor:"#FFF",borderWidth: "0 1px 1px 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0})}
                                                            />
                                                            <Input
                                                                value={child["效率值"].value}
                                                                onChange={(e) => {
                                                                    let newChildren = paramData.children.map(item =>item === child ? {...item,"效率值":{...item["效率值"],value:e.target.value}}:item);
                                                                    upParamData(paramData.engName,{children:newChildren})}}
                                                                style={{textAlign: "center",flex:1,minWidth:0,padding:0,height:expandEffRow.includes(index)? "100%" : 35,fontSize:14,color:"#5F5F5F",backgroundColor:"#FFF",borderWidth: "0 1px 1px 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0}}
                                                            />
                                                            <div style={{display:"flex",flexDirection:"column",textAlign: "center",flex:2,minWidth:0,height:expandEffRow.includes(index)? "auto" : 35,backgroundColor:"transparent",borderWidth: "0 1px 1px 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0,padding:0}}>
                                                              <div style={{display:"flex",justifyContent:"center",alignItems:"center",textAlign: "center",flex:1,height:35,backgroundColor:"transparent",borderWidth: "0 0 0 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0,padding:0}}>
                                                                  <button
                                                                    onClick={()=>{
                                                                      // debugger
                                                                      if(expandEffRow.includes(index))
                                                                      {
                                                                        let newExpandEffRow = structuredClone(expandEffRow);
                                                                        newExpandEffRow = newExpandEffRow.filter(item => item !== index);
                                                                        setExpandEffRow(newExpandEffRow);
                                                                      }
                                                                      else
                                                                      {
                                                                        let newExpandEffRow = structuredClone(expandEffRow);
                                                                        newExpandEffRow.push(index);
                                                                        setExpandEffRow(newExpandEffRow);
                                                                      }
                                                                    }}
                                                                    style={{textAlign: "center",flex:"0 0 auto",height:35,fontSize:14,color:"#1b6ae7",backgroundColor:"transparent",border:0,borderRadius:0}}
                                                                >
                                                                    {expandEffRow.includes(index)? "隐藏":"查看"}
                                                                </button>
                                                                <button
                                                                    onClick={()=>{
                                                                      // 打开弹窗时，勾选该行特殊效率中已有的组分
                                                                      const currentSpec = child?.["特殊效率"]?.children || [];
                                                                      // 快照原始 children，确认时据此找回已填的效率值（取消再勾回不清空）
                                                                      specOriginChildrenRef.current = currentSpec;
                                                                      setSpecChecked(currentSpec.map((sp: any) => sp?.["组分"]?.value).filter((v: any) => v));
                                                                      setSelectSpecModal({variable:true,index:index});
                                                                    }}
                                                                    style={{marginLeft:20,textAlign: "center",flex:"0 0 auto",height:35,fontSize:14,color:"#1b6ae7",backgroundColor:"transparent",border:0,borderRadius:0}}
                                                                >
                                                                    选择组分
                                                                </button>
                                                              </div>
                                                              
                                                              {expandEffRow.includes(index)? (
                                                                  (child?.["特殊效率"].children || []).map((spec: any, si: number) => (
                                                                      <div key={si} style={{display:"flex",flexDirection:"row",alignItems:"center",width:"100%",minHeight:35}}>
                                                                          <div style={{display:"flex",alignItems:"center",justifyContent:"center",flex:1,minWidth:0,height:30,fontSize:12,color:"#5F5F5F",padding:"0 2px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{spec?.["组分"]?.value}</div>
                                                                          <Input
                                                                              value={spec?.["效率值"]?.value}
                                                                              onChange={(e) => {
                                                                                  const newSpec = (child["特殊效率"].children || []).map((sp: any, j: number) => j === si ? {...sp,"效率值":{...(sp?.["效率值"]||{}),value:e.target.value}} : sp);
                                                                                  let newChildren = paramData.children.map(item =>item === child ? {...item,"特殊效率":{...item["特殊效率"],children:newSpec}}:item);
                                                                                  upParamData(paramData.engName,{children:newChildren})}}
                                                                              style={{flex:1,minWidth:0,width:"100%",marginRight:5,height:25,fontSize:14,color:"#5F5F5F",backgroundColor:"#FFF",borderWidth: "1px",borderStyle:"solid",borderColor:"#BBB",}}
                                                                          />
                                                                      </div>
                                                                  ))
                                                              ) : null}
                                                            </div>
                                                            <button
                                                                onClick={()=>{
                                                                    if(expandEffRow.includes(index))
                                                                    {
                                                                      let newExpandEffRow = structuredClone(expandEffRow);
                                                                      newExpandEffRow.filter(item => item !== index);
                                                                      setExpandEffRow(newExpandEffRow);
                                                                    }
                                                                    let newChildren = paramData.children.filter(item=>item!==child);
                                                                    upParamData(paramData.engName,{children:newChildren})}}
                                                                title="删除"
                                                                style={{textAlign: "center",width:60,height:expandEffRow.includes(index)? "100%" : 35,fontSize:14,color:"#FD7878",backgroundColor:"transparent",borderWidth: "0 1px 1px 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0}}
                                                            >
                                                                <DeleteOutlined/>
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 输出流量 */}
                                            {selectedElementData.elementNodeType==="Splitter" && paramData.engName==="output_f"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 40px)/3)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["输出流量"].value}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"输出流量":{...item["输出流量"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={{flex:1}}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 冷流股出口温度 */}
                                            {selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramData.engName==="cold_out_T"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 20px)/2)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["出口温度"].value}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"出口温度":{...item["出口温度"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={{flex:1}}
                                                              />
                                                              <Select
                                                                  value={child["出口温度"].unit}
                                                                  onChange={(val,e) => {
                                                                      let newChildren = paramData.children.map(item =>({...item,"出口温度":{...item["出口温度"],unit:val}}));
                                                                      upParamData(paramData.engName,{children:newChildren});
                                                                  }}
                                                                  style={{width:80,marginLeft:10}}
                                                                  options={(unitMap["T"].map(item => ({value:item,label:item})))}
                                                                  getPopupContainer={(trigger) => trigger.parentNode}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 热流股出口温度 */}
                                            {selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramData.engName==="hot_out_T"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 20px)/2)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["出口温度"].value}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"出口温度":{...item["出口温度"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={{flex:1}}
                                                              />
                                                              <Select
                                                                  value={child["出口温度"].unit}
                                                                  onChange={(val,e) => {
                                                                      let newChildren = paramData.children.map(item =>({...item,"出口温度":{...item["出口温度"],unit:val}}));
                                                                      upParamData(paramData.engName,{children:newChildren});
                                                                  }}
                                                                  style={{width:80,marginLeft:10}}
                                                                  options={(unitMap["T"].map(item => ({value:item,label:item})))}
                                                                  getPopupContainer={(trigger) => trigger.parentNode}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 冷流股出口压力 */}
                                            {selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramData.engName==="cold_out_P"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 20px)/2)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["出口压力"].value}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"出口压力":{...item["出口压力"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={{flex:1}}
                                                              />
                                                              <Select
                                                                  value={child["出口压力"].unit}
                                                                  onChange={(val,e) => {
                                                                      let newChildren = paramData.children.map(item =>({...item,"出口压力":{...item["出口压力"],unit:val}}));
                                                                      upParamData(paramData.engName,{children:newChildren});
                                                                  }}
                                                                  style={{width:80,marginLeft:10}}
                                                                  options={(unitMap["P"].map(item => ({value:item,label:item})))}
                                                                  getPopupContainer={(trigger) => trigger.parentNode}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 热流股出口压力 */}
                                            {selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramData.engName==="hot_out_P"?(
                                                <div style={{display:"flex",flexWrap:"wrap",alignContent:"flex-start",rowGap:"15px",columnGap:"20px",flex:1}}>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flexDirection:"row",flex:"0 0 calc((100% - 20px)/2)",alignItems:"center"}}>
                                                            <div style={{display:"flex",alignItems:"center",width:90,fontSize:14,color:"#5F5F5F"}}>{`${child["流股"].value}：`}</div>
                                                              <Input
                                                                  value={child["出口压力"].value}
                                                                  onChange={(e) => {
                                                                      let newChildren = paramData.children.map(item =>item === child ? {...item,"出口压力":{...item["出口压力"],value:e.target.value}}:item);
                                                                      upParamData(paramData.engName,{children:newChildren})}}
                                                                  style={{flex:1}}
                                                              />
                                                              <Select
                                                                  value={child["出口压力"].unit}
                                                                  onChange={(val,e) => {
                                                                      let newChildren = paramData.children.map(item =>({...item,"出口压力":{...item["出口压力"],unit:val}}));
                                                                      upParamData(paramData.engName,{children:newChildren});
                                                                  }}
                                                                  style={{width:80,marginLeft:10}}
                                                                  options={(unitMap["P"].map(item => ({value:item,label:item})))}
                                                                  getPopupContainer={(trigger) => trigger.parentNode}
                                                              />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                            {/* 出入流股关系 */}
                                            {selectedElementData.elementNodeType==="MultiStreamExchanger" && selectedElementData.elementSecondaryTypeName==="换热器4" && paramData.engName==="streamRelationship"?(
                                                <div style={{display:"flex",flexDirection:"column",flex:1}}>
                                                    <div style={{display:"flex",flexDirection:"row",height:35}}>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",border:"1px solid #BBB"}}>出口流股</div>
                                                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,fontWeight:"bold",color:"#5F5F5F",backgroundColor:"#EEE",borderWidth: "1px 1px 1px 0",borderStyle:"solid",borderColor:"#BBB"}}>入口流股</div>
                                                    </div>
                                                    {paramData.children.map((child) => (
                                                        <div style={{display:"flex",flex:1,flexDirection:"row",minHeight:35,maxHeight:35}}>
                                                            <div style={{display:"flex",justifyContent:"center",alignItems:"center",flex:1,fontSize:14,color:"#5F5F5F",borderWidth: "0 1px 1px 1px",borderStyle:"solid",borderColor:"#BBB"}}>{child["出口流股"].value}</div>
                                                            <Input
                                                                value={child["入口流股"].value}
                                                                onChange={(e) => {
                                                                    let newChildren = paramData.children.map(item =>item === child ? {...item,"入口流股":{...item["入口流股"],value:e.target.value}}:item);
                                                                    upParamData(paramData.engName,{children:newChildren})}}
                                                                style={{textAlign: "center",flex:1,minWidth:0,padding:0,height:35,fontSize:14,color:"#5F5F5F",backgroundColor:"#FFF",borderWidth: "0 1px 1px 0",borderStyle:"solid",borderColor:"#BBB",borderRadius:0}}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            ):null}

                                        </div>
                                    ):(null)}

                                    {/* 描述 */}
                                    {paramData.name==="描述"?(
                                        <div style={{display:"flex",flexDirection:"row",flex:1}}>
                                            <Input.TextArea
                                                value={paramData.value}
                                                onChange={(e) => {upParamData(paramData.engName,{value:e.target.value})}}
                                                autoSize={{maxRows:undefined}}
                                                style={{ flex: 1,minHeight:"100%",maxHeight:"100%"}}
                                            />
                                        </div>
                                    ):(null)}

                                    {/* 普通参数 */}
                                    {!(paramData.children)&&(paramData.name!=="描述")?(
                                        <div style={{display:"flex",flexDirection:"row",flex:1}}>
                                            <div style={{display:"flex",alignItems:"center",width:paramData.class!=="组分"?100:150,fontSize:14,color:"#5F5F5F"}}>{paramData.class!=="组分"?`${paramData.name}：`:`${rebuildFormula(paramData.engName)}（${paramData.name}）：`}</div>
                                            <div style={{display:"flex",flex:1,flexDirection:"row",marginLeft:10}}>
                                                {paramData.enum?(
                                                    <div style={{display:"flex",flexDirection:"row",flex:1}}>
                                                        {true?(
                                                            <Select
                                                                value={paramData.value}
                                                                onChange={(val,e) => {
                                                                    //需要特殊处理的参数
                                                                    if(paramData.engName==="internalType"||paramData.engName==="operatingSpecifications"||paramData.engName==="streamAttribute"||paramData.engName==="mode")
                                                                    {
                                                                        upParamData(paramData.engName,{value:val},true);
                                                                    }
                                                                    else
                                                                    {
                                                                        upParamData(paramData.engName,{value:val});
                                                                    }
                                                                }}
                                                                style={{flex:1}}
                                                                options={paramData.enum.map((opt:any) => ({label: opt.label,value: opt.value}))}
                                                                getPopupContainer={(trigger) => trigger.parentNode}
                                                            /> 
                                                        ):(
                                                            <div style={{flex:1,display:"flex",alignItems:"center",height:35,fontSize:14,color:"#5F5F5F"}}>
                                                                {(paramData.enum.map((opt:any) => ({label: opt.label,value: opt.value}))).find(item=>item.value===paramData.value)?.label}
                                                            </div>
                                                        )}
                                                    </div>
                                                ):(
                                                    <div style={{display:"flex",flexDirection:"row",flex:1}}>
                                                        {!(readonly && (paramData.engName==="nodeName"||paramData.engName==="linkName"||paramData.engName==="groupName"))?(
                                                            <Input
                                                                value={paramData.value}
                                                                onFocus={() => {
                                                                    //进入塔板数输入框时记录原塔板数，作为本次编辑联动的基准
                                                                    if(paramData.engName==="N" && selectedElementData?.elementNodeType==="DistilStrict")
                                                                    {
                                                                        let storedValue = paramDatasRef.current?.flatMap((classData)=>classData.params).find((param)=>param.engName==="N")?.value;
                                                                        let storedNum = Number(storedValue);
                                                                        trayCountBaseRef.current = (storedValue===""||storedValue===null||storedValue===undefined||Number.isNaN(storedNum)) ? null : storedNum;
                                                                        trayLinkedFieldsRef.current = [];
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    //需要特殊处理的参数
                                                                    if(paramData.engName==="internalType"||paramData.engName==="operatingSpecifications"||paramData.engName==="streamAttribute")
                                                                    {
                                                                        upParamData(paramData.engName,{value:e.target.value},true);
                                                                    }
                                                                    else
                                                                    {
                                                                        upParamData(paramData.engName,{value:e.target.value});
                                                                    }
                                                                }}
                                                                style={{flex:1}}
                                                            />
                                                        ):(
                                                            <div style={{flex:1,display:"flex",alignItems:"center",height:35,fontSize:14,color:"#5F5F5F"}}>
                                                                {paramData.value}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {paramData.unit?(
                                                    <div style={{width:80,marginLeft:10}}>
                                                        <Select
                                                            value={paramData.unitValue}
                                                            onChange={(val,e) => {
                                                                //需要特殊处理的参数
                                                                if(paramData.unitField)
                                                                {
                                                                    upParamData(paramData.engName,{unitValue:val},true);
                                                                }
                                                                else
                                                                {
                                                                    upParamData(paramData.engName,{unitValue:val});
                                                                }
                                                            }}
                                                            style={{display:"flex",flex:1}}
                                                            options={paramData.unit.filter((opt:any) => {
                                                                //流量单位 Nm3/h 仅在流股相态为汽相(V)时显示
                                                                if (paramData.engName === "f" && opt.value === "Nm3/h") {
                                                                    const phaseData = paramDatas?.find((c:any) => c.className === "规定")?.params.find((p:any) => p.engName === "phase");
                                                                    return phaseData?.value === "V";
                                                                }
                                                                return true;
                                                            }).map((opt:any) => ({label: opt.label,value: opt.value}))}
                                                            getPopupContainer={(trigger) => trigger.parentNode}
                                                        />
                                                    </div>
                                                    
                                                ):null}
                                            </div>
                                        </div>
                                    ):(null)}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* <div style={{display:"flex",flexDirection: "column",flex:1,backgroundColor:"transparent",marginLeft:20,marginRight:20,marginBottom:15,overflowY: "auto"}}>
          <div style={{display:"flex",flexDirection: "row"}}>
            {isShowDescription?(
              <div style={{width:280,marginRight:20}}>

                <div style={{height:elementPage?"40%":"100%",marginTop:"5%"}}>
                  <div
                    key={"描述"}
                    style={{ display: "flex", marginBottom: "10px",height:"100%"}}
                  >
                    <div style={{ width: "40px", fontSize: 14,marginTop:5 }}>描述</div>

                    {readonly?(
                      <div style={{ flex: 1,minHeight:"100%",maxHeight:"100%",fontSize:14,color:"#000",marginTop:5}}>
                        {localFormData?.["描述"]?.value ?? ""}
                      </div>
                    ):(
                      <Input.TextArea
                        autoSize={{maxRows:undefined}}
                        value={localFormData?.["描述"]?.value ?? ""}
                        onChange={(e) => {
                          setLocalFormData((prev) => ({
                            ...prev,
                            ["描述"]: {
                              value: e.target.value,
                              show: false,
                              engName: "description",
                            },
                          }));
                        }}
                        style={{ flex: 1,minHeight:"100%",maxHeight:"100%"}}
                      />
                    )}
                  </div>
                </div>
              </div>
            ):null}

            <div style={{ maxHeight: maxHeight,padding: 10,width:"100%" }}>

              {localFormData &&
                typeof localFormData === "object" &&
                !Array.isArray(localFormData) &&
                Object.entries(localFormData).map(([key]) => (
                  <div
                    key={key}
                    style={{
                      display:localFormData[key]?.show===undefined ? "flex" : (localFormData[key].show===false?"none":"flex"),
                      // display: "flex",
                      alignItems: "center", marginBottom: "10px" }}
                  >
                    <div style={{ width: "120px", fontSize: 14 }}>{key==="分组名称"?"工艺段名称":key}</div>
                    {localFormData[key]?.enum ? (
                      <Select
                        value={localFormData[key]?.value ?? ""}
                        onChange={(selectedValue) => 
                        {
                          if(key==="计算模式" && localParamValues["温度"] && localParamValues["汽相分率"])
                          {
                            if(selectedValue==="TP")
                            {
                              setLocalFormData((prev) => ({
                                ...prev,
                                [key]: {
                                  value: selectedValue,
                                  show: localFormData[key].show ?? false,
                                  engName: localFormData[key].engName ?? "",
                                  enum: localFormData[key].enum ?? null,
                                },
                              }));
                              setLocalParamValues((prev) => ({
                                ...prev,
                                ["温度"]:{
                                  ...prev["温度"],
                                  show:true,
                                },
                                ["汽相分率"]:{
                                  ...prev["汽相分率"],
                                  show:false,
                                }
                              }));
                            }
                            else if(selectedValue==="VP"||selectedValue==="HP")
                            {
                              setLocalFormData((prev) => ({
                                ...prev,
                                [key]: {
                                  value: selectedValue,
                                  show: localFormData[key].show ?? false,
                                  engName: localFormData[key].engName ?? "",
                                  enum: localFormData[key].enum ?? null,
                                },
                              }));
                              setLocalParamValues((prev) => ({
                                ...prev,
                                ["温度"]:{
                                  ...prev["温度"],
                                  show:false,
                                },
                                ["汽相分率"]:{
                                  ...prev["汽相分率"],
                                  show:true,
                                }
                              }));
                            }
                          }
                          else
                          {
                            setLocalFormData((prev) => ({
                              ...prev,
                              [key]: {
                                value: selectedValue,
                                show: localFormData[key].show ?? false,
                                engName: localFormData[key].engName ?? "",
                                enum: localFormData[key].enum ?? null,
                              },
                            }));
                          }
                        }}
                        style={{ flex: 1 }}
                        options={localFormData[key].enum.map((opt: any) => ({
                          label: opt.label,
                          value: opt.value,
                        }))}
                      />
                    ) : (
                      <div style={{ flex: 1 }}>
                        {(readonly && (key==="元件名称"||key==="流股名称"||key==="分组名称"))?
                          (
                            <div style={{ flex:1, fontSize: 14,marginBottom:10 }}>
                              {localFormData[key]?.value ?? ""}
                            </div>
                          ):
                          (
                            <Input
                              value={localFormData[key]?.value ?? ""}
                              onChange={(e) => {
                                setLocalFormData((prev) => ({
                                  ...prev,
                                  [key]: {
                                    value: e.target.value,
                                    show: localFormData[key].show ?? false,
                                    engName: localFormData[key].engName ?? "",
                                  },
                                }));
                              }}
                              style={{ flex: 1 }}
                            />
                          )
                        }
                      </div>
                    )}
                  </div>
                ))}

              {modalParams &&
                Array.isArray(modalParams) &&
                modalParams.filter(item=>!item.p_class).map((item) => (
                  <div
                    key={item?.p_name}
                    style={{
                      // display: item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none",
                      display: ((localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])&&(item.p_engName==="cold_out_T"||item.p_engName==="cold_out_P"||item.p_engName==="hot_out_T"||item.p_engName==="hot_out_P"))?"flex":
                      ((localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])&&(item.p_engName==="streamAttribute")?"none":
                      (item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none")),
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: item.p_show||localParamValues[item.p_name]?.show ? "10px" : "0px",
                    }}
                  >
                    {item.p_children && Array.isArray(item.p_children) && item.p_children.length > 0 ? (
                      <div style={{ width: "100%", marginBottom: "10px" }}>
                        {!(item.p_engName === "No" || item.p_engName === "Ns" || item.p_engName === "output_f" || item.p_engName === "cold_out_T" || item.p_engName === "hot_out_T" || item.p_engName === "cold_out_P" || item.p_engName === "hot_out_P" || item.p_engName === "stream_type" || item.p_engName === "streamRelationship" ) ? (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "120px",
                                  fontSize: 14,
                                  fontWeight: "bold",
                                  color: "#1b6ae7",
                                }}
                              >
                                {item.p_name}
                              </div>
                              <Button
                                type="text"
                                style={{
                                  height: 30,
                                  width: 30,
                                  borderRadius: 50,
                                  backgroundColor: "#FFF",
                                }}
                                onClick={() => 
                                {
                                  setLocalParamValues((prev) => {
                                    const current = prev[item.p_name] || {
                                      p_children: [],
                                      show: item.p_show,
                                      engName: item.p_engName,
                                    };
                                    const newChild: any = {};
                                    item.p_children.forEach((sub: any) => {
                                      newChild[sub.p_name] = {
                                        // value: (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                        //   ?.find((c: any) => c.p_name === sub.p_name)?.p_value,
                                        value: (
                                          (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[0]?.[sub.p_engName] )
                                          ??(modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                          ?.find((c: any) => c.p_name === sub.p_name)?.p_value),
                                        desValue: (
                                          (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[0]?.[sub.p_engName] )
                                          ??(modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                          ?.find((c: any) => c.p_name === sub.p_name)?.p_value),
                                        show: sub.p_show ?? true,
                                        engName: sub.p_engName ?? "",

                                      };
                                      if(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children)
                                      {
                                        let children = [];
                                        if(sub.p_engName==="spec")
                                        {
                                          for(let i=0;i<globalData.materials.length;i++)
                                          {
                                            let child = 
                                            {
                                              "组分": 
                                              {
                                                value: globalData.materials[i].name,
                                                show:true,
                                                engName: "组分",
                                                readonly:true,
                                              },
                                              "效率值": 
                                              {
                                                value:(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                                desValue:(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                                show:true,
                                                engName:"效率值",
                                              },
                                            };
                                            children.push(child);
                                          }
                                        }
                                        newChild[sub.p_name].children = children;
                                      }
                                    });
                                    const newChildren = [...(current.p_children || []), newChild];
                                    return {
                                      ...prev,
                                      [item.p_name]: {
                                        ...current,
                                        p_children: newChildren,
                                      },
                                    };
                                  });
                                }}
                              >
                                <PlusCircleOutlined style={{ fontSize: 20, color: "#1b6ae7" }} />
                              </Button>
                            </div>
                            {(localParamValues[item.p_name]?.p_children || []).map((child: any, idx: number) => (
                              <div
                                key={idx}
                                style={{
                                  border: "1px solid #BBB",
                                  padding: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                    paddingRight: "10px",
                                  }}
                                >
                                  <Button type="text" style={{height: 30,width: 30,borderRadius: 50,backgroundColor: "#FFF",}}
                                    onClick={() =>
                                    {
                                      let children = []
                                      if(item.p_engName==="eff")
                                      {
                                        for(let i=0;i<globalData.materials.length;i++)
                                        {
                                          let child = 
                                          {
                                            "组分": 
                                            {
                                              value: globalData.materials[i].name,
                                              show:true,
                                              engName: "组分",
                                              readonly:true,
                                            },
                                            "效率值": 
                                            {
                                              value:(item.p_children.find(field=>field.p_engName==="spec")?.p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                              desValue:(item.p_children.find(field=>field.p_engName==="spec")?.p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                              show:true,
                                              engName:"效率值",
                                            },
                                          };
                                          children.push(child);
                                        }
                                        setLocalParamValues(prev => ({
                                          ...prev,
                                          [item.p_name]: {
                                            ...prev[item.p_name],
                                            p_children: prev[item.p_name].p_children.map((child, i) =>
                                              i === idx ? { ...child, "特殊效率": { ...child["特殊效率"], show:!child["特殊效率"]?.show,children:children} } : child
                                            )
                                          }
                                        }));
                                      }
                                      else
                                      {
                                        messageApi.open({
                                          type: "error",
                                          content: "暂无额外数据",
                                        });
                                      }
                                    }}
                                  >
                                    <EllipsisOutlined style={{ fontSize: 20, color: "#1b6ae7" }} />
                                  </Button>

                                  <Button
                                    type="text"
                                    style={{
                                      height: 30,
                                      width: 30,
                                      borderRadius: 50,
                                      backgroundColor: "#FFF",
                                    }}
                                    onClick={() => {
                                      setLocalParamValues((prev) => {
                                        const current = prev[item.p_name];
                                        const newChildren = current.p_children.filter(
                                          (_: any, i: number) => i !== idx
                                        );
                                        return {
                                          ...prev,
                                          [item.p_name]: {
                                            ...current,
                                            p_children: newChildren,
                                          },
                                        };
                                      });
                                    }}
                                  >
                                    <DeleteOutlined style={{ fontSize: 20, color: "#FF4D4F" }} />
                                  </Button>
                                </div>
                                {item.p_children.map((sub: any) => (
                                  <div
                                    key={sub.p_name}
                                    style={{display:sub.p_show||child[sub.p_name]?.show?"flex":"none",alignItems:child[sub.p_name]?.children?"stretch":"center",marginTop:child[sub.p_name]?.children?15:0,marginBottom: "10px"}}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>{sub.p_name}</div>
                                    {sub.p_children ? (
                                      <div style={{ flex: 1 }}>
                                        {(child[sub.p_name].children || []).map((child2,idx2) => (
                                          <div key={idx2} style={{border: '1px solid #BBB',marginBottom:10,padding:10}}>
                                            {sub.p_children.map((field) => (
                                              <div
                                                key={field.p_name}
                                                style={{ display:'flex',alignItems:'center',marginBottom:10}}
                                              >
                                                <div style={{ width:80,fontSize:14}}>{field.p_name}</div>
                                                {child2[field.p_name].readonly ? (
                                                  <div style={{ flex: 1,fontSize:14 }}>{child2[field.p_name].value??''}</div>
                                                ) : (
                                                  <div style={{ flex: 1,display:"flex",flexDirection:"row"}}>
                                                    <Input
                                                      value={child2[field.p_name].value ?? ''}
                                                      onChange={(e) => 
                                                      {
                                                        const newVal = e.target.value;
                                                        // 更新 specChild 中对应字段的值
                                                        const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                        newSpecChildren[idx2] = {
                                                          ...newSpecChildren[idx2],
                                                          [field.p_name]: {
                                                            ...newSpecChildren[idx2][field.p_name],
                                                            value: newVal,
                                                          },
                                                        };
                                                        const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                        newChildren[idx] = {
                                                          ...child,
                                                          [sub.p_name]: {
                                                            ...child[sub.p_name],
                                                            children: newSpecChildren,
                                                          },
                                                        };
                                                        setLocalParamValues((prev: any) => ({
                                                          ...prev,
                                                          [item.p_name]: {
                                                            ...prev[item.p_name],
                                                            p_children: newChildren,
                                                          },
                                                        }));
                                                      }}
                                                      style={{ flex: 1 }}
                                                    />
                                                    {(designVisible?(
                                                      <Input
                                                        value={child2[field.p_name].desValue ?? ''}
                                                        onChange={(e) => 
                                                        {
                                                          const newVal = e.target.value;
                                                          // 更新 specChild 中对应字段的值
                                                          const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                          newSpecChildren[idx2] = {
                                                            ...newSpecChildren[idx2],
                                                            [field.p_name]: {
                                                              ...newSpecChildren[idx2][field.p_name],
                                                              desValue: newVal,
                                                            },
                                                          };
                                                          const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                          newChildren[idx] = {
                                                            ...child,
                                                            [sub.p_name]: {
                                                              ...child[sub.p_name],
                                                              children: newSpecChildren,
                                                            },
                                                          };
                                                          setLocalParamValues((prev: any) => ({
                                                            ...prev,
                                                            [item.p_name]: {
                                                              ...prev[item.p_name],
                                                              p_children: newChildren,
                                                            },
                                                          }));
                                                        }}
                                                        style={{ flex: 1,marginLeft:10 }}
                                                      />
                                                    ):null)}
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div style={{flex:1,display:"flex",flexDirection:"row"}}>
                                        <Input
                                          value={child[sub.p_name]?.value ?? ''}
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              [sub.p_name]: {
                                                ...newChildren[idx]?.[sub.p_name],
                                                value: newVal,
                                              },
                                            };
                                            setLocalParamValues((prev: any) => ({
                                              ...prev,
                                              [item.p_name]: {
                                                ...prev[item.p_name],
                                                p_children: newChildren,
                                              },
                                            }));
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={child[sub.p_name]?.desValue ?? ''}
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                [sub.p_name]: {
                                                  ...newChildren[idx]?.[sub.p_name],
                                                  desValue: newVal,
                                                },
                                              };
                                              setLocalParamValues((prev: any) => ({
                                                ...prev,
                                                [item.p_name]: {
                                                  ...prev[item.p_name],
                                                  p_children: newChildren,
                                                },
                                              }));
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "120px",
                                  fontSize: 14,
                                  fontWeight: "bold",
                                  color: "#1b6ae7",
                                }}
                              >
                                {item.p_name}
                              </div>
                            </div>
                            {item.p_engName === "No" && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>出料位置</div>
                                        <Input
                                          value={
                                            child["出料位置"].value
                                              ? child["出料位置"].value
                                              : child["出料位置"].value === ""
                                              ? ""
                                              : 
                                              // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              //     ?.find((c: any) => c.p_name === "出料位置")?.p_value)
                                              (
                                                (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "出料位置")?.p_value))
                                          }
                                          onChange={(e) => 
                                          {
                                            const newVal = e.target.value;
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["出料位置"]: {
                                                  ...newChildren[idx]["出料位置"],
                                                  value: newVal,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });

                                            // let N = Number(localParamValues["塔板数"].value);
                                            // if (Number.isNaN(N))
                                            // {
                                            //   N = null;
                                            // }
                                            // let newValNum = Number(newVal);
                                            // if (Number.isNaN(newValNum))
                                            // {
                                            //   newValNum = null;
                                            // }
                                            // if(N && newValNum && newValNum<=N && newValNum>=1 && Number.isInteger(newValNum))
                                            // {
                                            //   //恢复状态
                                            //   let newErrorInputs = [...errorInputs];
                                            //   newErrorInputs = newErrorInputs.filter(i => i !== `${item.p_engName}_${idx}`)
                                            //   setErrorInputs(newErrorInputs);
                                            // }
                                            // else
                                            // {
                                            //   //error状态
                                            //   let newErrorInputs = [...errorInputs];
                                            //   newErrorInputs.push(`${item.p_engName}_${idx}`);
                                            //   setErrorInputs(newErrorInputs);
                                            // }

                                          }}
                                          style={{ flex: 1 }}
                                          status={errorInputs.includes(`${item.p_engName}_${idx}`)?"error":""}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={
                                              child["出料位置"]?.desValue
                                                ? child["出料位置"]?.desValue
                                                : child["出料位置"]?.desValue === ""
                                                ? ""
                                                : 
                                                // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                //     ?.find((c: any) => c.p_name === "出料位置")?.p_value)
                                                (
                                                  (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                  ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                    ?.find((c: any) => c.p_name === "出料位置")?.p_value))
                                            }
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              setLocalParamValues((prev) => {
                                                const current = prev[item.p_name];
                                                const newChildren = [...(current?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  ["出料位置"]: {
                                                    ...newChildren[idx]["出料位置"],
                                                    desValue: newVal,
                                                  },
                                                };
                                                return {
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...current,
                                                    p_children: newChildren,
                                                  },
                                                };
                                              });
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {item.p_engName === "Ns" && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>进料位置</div>
                                        <Input
                                          value={
                                            child["进料位置"].value
                                              ? child["进料位置"].value
                                              : child["进料位置"].value === ""
                                              ? ""
                                              :
                                              // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              //     ?.find((c: any) => c.p_name === "进料位置")?.p_value)
                                              (
                                                (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["inputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "进料位置")?.p_value))
                                          }
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["进料位置"]: {
                                                  ...newChildren[idx]["进料位置"],
                                                  value: newVal,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });

                                            // let N = Number(localParamValues["塔板数"].value);
                                            // if (Number.isNaN(N))
                                            // {
                                            //   N = null;
                                            // }
                                            // let newValNum = Number(newVal);
                                            // if (Number.isNaN(newValNum))
                                            // {
                                            //   newValNum = null;
                                            // }
                                            // if(N && newValNum && newValNum<=N && newValNum>=1 && Number.isInteger(newValNum))
                                            // {
                                            //   //恢复状态
                                            //   let newErrorInputs = [...errorInputs];
                                            //   newErrorInputs = newErrorInputs.filter(i => i !== `${item.p_engName}_${idx}`)
                                            //   setErrorInputs(newErrorInputs);
                                            // }
                                            // else
                                            // {
                                            //   //error状态
                                            //   let newErrorInputs = [...errorInputs];
                                            //   newErrorInputs.push(`${item.p_engName}_${idx}`);
                                            //   setErrorInputs(newErrorInputs);
                                            // }
                                          }}
                                          style={{ flex: 1 }}
                                          status={errorInputs.includes(`${item.p_engName}_${idx}`)?"error":""}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={
                                              child["进料位置"]?.desValue
                                                ? child["进料位置"]?.desValue
                                                : child["进料位置"]?.desValue === ""
                                                ? ""
                                                : 
                                                // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                //     ?.find((c: any) => c.p_name === "进料位置")?.p_value)
                                                (
                                                  (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["inputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                  ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                    ?.find((c: any) => c.p_name === "进料位置")?.p_value))
                                            }
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              setLocalParamValues((prev) => {
                                                const current = prev[item.p_name];
                                                const newChildren = [...(current?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  ["进料位置"]: {
                                                    ...newChildren[idx]["进料位置"],
                                                    desValue: newVal,
                                                  },
                                                };
                                                return {
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...current,
                                                    p_children: newChildren,
                                                  },
                                                };
                                              });
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {item.p_engName === "output_f" && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>输出流量</div>
                                        <Input
                                          value={
                                            child["输出流量"].value
                                              ? child["输出流量"].value
                                              : child["输出流量"].value === ""
                                              ? ""
                                              :
                                              // (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              //   ?.find((c: any) => c.p_name === "输出流量")?.p_value
                                              (
                                                (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "输出流量")?.p_value))
                                          }
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["输出流量"]: {
                                                  ...newChildren[idx]["输出流量"],
                                                  value: newVal,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={
                                              child["输出流量"].desValue
                                                ? child["输出流量"].desValue
                                                : child["输出流量"].desValue === ""
                                                ? ""
                                                :
                                                // (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                //   ?.find((c: any) => c.p_name === "输出流量")?.p_value
                                                (
                                                  (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                                  ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                    ?.find((c: any) => c.p_name === "输出流量")?.p_value))
                                            }
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              setLocalParamValues((prev) => {
                                                const current = prev[item.p_name];
                                                const newChildren = [...(current?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  ["输出流量"]: {
                                                    ...newChildren[idx]["输出流量"],
                                                    desValue: newVal,
                                                  },
                                                };
                                                return {
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...current,
                                                    p_children: newChildren,
                                                  },
                                                };
                                              });
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {(item.p_engName === "cold_out_T" || item.p_engName === "hot_out_T") && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>出口温度</div>
                                        <Input
                                          value={
                                            child["出口温度"].value
                                              ? child["出口温度"].value
                                              : child["出口温度"].value === ""
                                              ? ""
                                              :
                                              (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                ?.find((c: any) => c.p_name === "出口温度")?.p_value
                                          }
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["出口温度"]: {
                                                  ...newChildren[idx]["出口温度"],
                                                  value: newVal,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={
                                              child["出口温度"]?.desValue
                                                ? child["出口温度"]?.desValue
                                                : child["出口温度"]?.desValue === ""
                                                ? ""
                                                :
                                                (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "出口温度")?.p_value
                                            }
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              setLocalParamValues((prev) => {
                                                const current = prev[item.p_name];
                                                const newChildren = [...(current?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  ["出口温度"]: {
                                                    ...newChildren[idx]["出口温度"],
                                                    desValue: newVal,
                                                  },
                                                };
                                                return {
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...current,
                                                    p_children: newChildren,
                                                  },
                                                };
                                              });
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                        <Select
                                          value={child["出口温度"].unit}
                                          onChange={(selectedUnit) => 
                                          {
                                            const unitField = item.p_children.find(i=>i.p_unitField).p_unitField;
                                            let newValues = { ...localParamValues };
                                            if (unitField) 
                                            {
                                              const coldCurrent = localParamValues["冷流股出口温度"];
                                              const coldNewChildren = [...(coldCurrent?.p_children || [])];
                                              for(let i=0;i<coldNewChildren.length;i++)
                                              {
                                                coldNewChildren[i] = 
                                                {
                                                  ...coldNewChildren[i],
                                                  ["出口温度"]: {
                                                    ...coldNewChildren[i]["出口温度"],
                                                    unit: selectedUnit,
                                                  },
                                                };
                                              }
                                              const hotCurrent = localParamValues["热流股出口温度"];
                                              const hotNewChildren = [...(hotCurrent?.p_children || [])];
                                              for(let i=0;i<hotNewChildren.length;i++)
                                              {
                                                hotNewChildren[i] = 
                                                {
                                                  ...hotNewChildren[i],
                                                  ["出口温度"]: {
                                                    ...hotNewChildren[i]["出口温度"],
                                                    unit: selectedUnit,
                                                  },
                                                };
                                              }
                                              setLocalParamValues((prev: any) => ({
                                                ...prev,
                                                ["冷流股出口温度"]: {
                                                  ...prev["冷流股出口温度"],
                                                  p_children: coldNewChildren,
                                                },
                                                ["热流股出口温度"]: {
                                                  ...prev["热流股出口温度"],
                                                  p_children: hotNewChildren,
                                                },
                                              }));
                                            }
                                          }}
                                          style={{ marginLeft: "10px", width: "100px" }}
                                          options={unitMap[item.p_children.find(i=>i.p_type).p_type].map((unit: string) => ({ label: unit, value: unit }))}
                                        />
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {(item.p_engName === "cold_out_P" || item.p_engName === "hot_out_P") && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>出口压力</div>
                                        <Input
                                          value={
                                            child["出口压力"].value
                                              ? child["出口压力"].value
                                              : child["出口压力"].value === ""
                                              ? ""
                                              :
                                              (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                ?.find((c: any) => c.p_name === "出口压力")?.p_value
                                          }
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["出口压力"]: {
                                                  ...newChildren[idx]["出口压力"],
                                                  value: newVal,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={
                                              child["出口压力"]?.desValue
                                                ? child["出口压力"]?.desValue
                                                : child["出口压力"]?.desValue === ""
                                                ? ""
                                                :
                                                (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "出口压力")?.p_value
                                            }
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              setLocalParamValues((prev) => {
                                                const current = prev[item.p_name];
                                                const newChildren = [...(current?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  ["出口压力"]: {
                                                    ...newChildren[idx]["出口压力"],
                                                    desValue: newVal,
                                                  },
                                                };
                                                return {
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...current,
                                                    p_children: newChildren,
                                                  },
                                                };
                                              });
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                        <Select
                                          value={child["出口压力"].unit}
                                          onChange={(selectedUnit) => 
                                          {
                                            const unitField = item.p_children.find(i=>i.p_unitField).p_unitField;
                                            let newValues = { ...localParamValues };
                                            if (unitField) 
                                            {
                                              const coldCurrent = localParamValues["冷流股出口压力"];
                                              const coldNewChildren = [...(coldCurrent?.p_children || [])];
                                              for(let i=0;i<coldNewChildren.length;i++)
                                              {
                                                coldNewChildren[i] = 
                                                {
                                                  ...coldNewChildren[i],
                                                  ["出口压力"]: {
                                                    ...coldNewChildren[i]["出口压力"],
                                                    unit: selectedUnit,
                                                  },
                                                };
                                              }
                                              const hotCurrent = localParamValues["热流股出口压力"];
                                              const hotNewChildren = [...(hotCurrent?.p_children || [])];
                                              for(let i=0;i<hotNewChildren.length;i++)
                                              {
                                                hotNewChildren[i] = 
                                                {
                                                  ...hotNewChildren[i],
                                                  ["出口压力"]: {
                                                    ...hotNewChildren[i]["出口压力"],
                                                    unit: selectedUnit,
                                                  },
                                                };
                                              }
                                              setLocalParamValues((prev: any) => ({
                                                ...prev,
                                                ["冷流股出口压力"]: {
                                                  ...prev["冷流股出口压力"],
                                                  p_children: coldNewChildren,
                                                },
                                                ["热流股出口压力"]: {
                                                  ...prev["热流股出口压力"],
                                                  p_children: hotNewChildren,
                                                },
                                              }));
                                            }
                                          }}
                                          style={{ marginLeft: "10px", width: "100px" }}
                                          options={unitMap[item.p_children.find(i=>i.p_type).p_type].map((unit: string) => ({ label: unit, value: unit }))}
                                        />
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {item.p_engName === "stream_type" && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map((child: any, idx: number) => (
                                  <div
                                    key={idx}
                                    style={{
                                      border: "1px solid #BBB",
                                      padding: "10px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    {item.p_children.map((sub: any) => (
                                      <div
                                        key={sub.p_name}
                                        style={{display:sub.p_show||child[sub.p_name]?.show?"flex":"none",alignItems:child[sub.p_name]?.children?"stretch":"center",marginTop:child[sub.p_name]?.children?15:0,marginBottom: "10px"}}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>{sub.p_name}</div>
                                        {sub.p_children ? (
                                          <div style={{ flex: 1 }}>
                                            {(child[sub.p_name].children || []).map((child2,idx2) => (
                                              <div key={idx2} style={{border: '1px solid #BBB',marginBottom:10,padding:10}}>
                                                {sub.p_children.map((field) => (
                                                  <div
                                                    key={field.p_name}
                                                    style={{ display:'flex',alignItems:'center',marginBottom:10}}
                                                  >
                                                    <div style={{ width:80,fontSize:14}}>{field.p_name}</div>
                                                    {child2[field.p_name].readonly ? (
                                                      <div style={{ flex: 1,fontSize:14 }}>{child2[field.p_name].value??''}</div>
                                                    ) : (
                                                      <div style={{ flex: 1,display:"flex",flexDirection:"row"}}>
                                                        <Input
                                                          value={child2[field.p_name].value ?? ''}
                                                          onChange={(e) => 
                                                          {
                                                            const newVal = e.target.value;
                                                            // 更新 specChild 中对应字段的值
                                                            const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                            newSpecChildren[idx2] = {
                                                              ...newSpecChildren[idx2],
                                                              [field.p_name]: {
                                                                ...newSpecChildren[idx2][field.p_name],
                                                                value: newVal,
                                                              },
                                                            };
                                                            const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                            newChildren[idx] = {
                                                              ...child,
                                                              [sub.p_name]: {
                                                                ...child[sub.p_name],
                                                                children: newSpecChildren,
                                                              },
                                                            };
                                                            setLocalParamValues((prev: any) => ({
                                                              ...prev,
                                                              [item.p_name]: {
                                                                ...prev[item.p_name],
                                                                p_children: newChildren,
                                                              },
                                                            }));
                                                          }}
                                                          style={{ flex: 1 }}
                                                        />
                                                        {(designVisible?(
                                                          <Input
                                                            value={child2[field.p_name].desValue ?? ''}
                                                            onChange={(e) => 
                                                            {
                                                              const newVal = e.target.value;
                                                              // 更新 specChild 中对应字段的值
                                                              const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                              newSpecChildren[idx2] = {
                                                                ...newSpecChildren[idx2],
                                                                [field.p_name]: {
                                                                  ...newSpecChildren[idx2][field.p_name],
                                                                  desValue: newVal,
                                                                },
                                                              };
                                                              const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                              newChildren[idx] = {
                                                                ...child,
                                                                [sub.p_name]: {
                                                                  ...child[sub.p_name],
                                                                  children: newSpecChildren,
                                                                },
                                                              };
                                                              setLocalParamValues((prev: any) => ({
                                                                ...prev,
                                                                [item.p_name]: {
                                                                  ...prev[item.p_name],
                                                                  p_children: newChildren,
                                                                },
                                                              }));
                                                            }}
                                                            style={{ flex: 1,marginLeft:10 }}
                                                          />
                                                        ):null)}
                                                      </div>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <div style={{flex:1,display:"flex",flexDirection:"row"}}>
                                            <Input
                                              value={child[sub.p_name]?.value ?? ''}
                                              onChange={(e) => {
                                                const newVal = e.target.value;
                                                const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                newChildren[idx] = {
                                                  ...newChildren[idx],
                                                  [sub.p_name]: {
                                                    ...newChildren[idx]?.[sub.p_name],
                                                    value: newVal,
                                                  },
                                                };
                                                setLocalParamValues((prev: any) => ({
                                                  ...prev,
                                                  [item.p_name]: {
                                                    ...prev[item.p_name],
                                                    p_children: newChildren,
                                                  },
                                                }));
                                              }}
                                              style={{ flex: 1 }}
                                            />
                                            {(designVisible?(
                                              <Input
                                                value={child[sub.p_name]?.desValue ?? ''}
                                                onChange={(e) => {
                                                  const newVal = e.target.value;
                                                  const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                  newChildren[idx] = {
                                                    ...newChildren[idx],
                                                    [sub.p_name]: {
                                                      ...newChildren[idx]?.[sub.p_name],
                                                      desValue: newVal,
                                                    },
                                                  };
                                                  setLocalParamValues((prev: any) => ({
                                                    ...prev,
                                                    [item.p_name]: {
                                                      ...prev[item.p_name],
                                                      p_children: newChildren,
                                                    },
                                                  }));
                                                }}
                                                style={{ flex: 1,marginLeft:10 }}
                                              />
                                            ):null)}
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ))}
                              </div>
                            )}
                            {item.p_engName === "streamRelationship" && (
                              <div>
                                {(localParamValues[item.p_name]?.p_children || []).map(
                                  (child: any, idx: number) => (
                                    <div
                                      key={idx}
                                      style={{
                                        border: "1px solid #BBB",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div style={{ width: "100px", fontSize: 14 }}>出口流股</div>
                                        <div style={{ flex: 1, fontSize: 14 }}>
                                          {child["出口流股"]?.value}
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{ width: "100px", fontSize: 14 }}>入口流股</div>
                                        <Select
                                          value={
                                            child["入口流股"].value
                                              ? child["入口流股"].value
                                              : child["入口流股"].value === ""
                                              ? ""
                                              :
                                              // (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              //   ?.find((c: any) => c.p_name === "入口流股")?.p_value
                                              (
                                                (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["出口流股"]?.value??""))])
                                                ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                  ?.find((c: any) => c.p_name === "入口流股")?.p_value))
                                          }
                                          onChange={(selectedValue) => 
                                          {
                                            setLocalParamValues((prev) => {
                                              const current = prev[item.p_name];
                                              const newChildren = [...(current?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                ["入口流股"]: {
                                                  ...newChildren[idx]["入口流股"],
                                                  value: selectedValue,
                                                },
                                              };
                                              return {
                                                ...prev,
                                                [item.p_name]: {
                                                  ...current,
                                                  p_children: newChildren,
                                                },
                                              };
                                            });
                                          }}
                                          style={{ flex: 1 }}
                                          options={child["入口流股"].enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                                        />
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <div style={{ width: "120px", fontSize: 14 }}>{item?.p_name}</div>
                        {item.enum && Array.isArray(item.enum) && item.enum.length > 0 ? (
                          <Select
                            value={localParamValues[item?.p_name]?.value}
                            onChange={(selectedValue) => 
                            {
                              //特殊处理
                              if(item?.p_name==="流股属性" && localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])
                              {
                                if(selectedValue==="冷流股")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue:selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["冷流股出口温度"]:{
                                      ...prev["冷流股出口温度"],
                                      show:true,
                                    },
                                    ["热流股出口温度"]:{
                                      ...prev["热流股出口温度"],
                                      show:false,
                                    },
                                    ["冷流股出口压力"]:{
                                      ...prev["冷流股出口压力"],
                                      show:true,
                                    },
                                    ["热流股出口压力"]:{
                                      ...prev["热流股出口压力"],
                                      show:false,
                                    },
                                  }));
                                }
                                else if(selectedValue==="热流股")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue: selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["冷流股出口温度"]:{
                                      ...prev["冷流股出口温度"],
                                      show:false,
                                    },
                                    ["热流股出口温度"]:{
                                      ...prev["热流股出口温度"],
                                      show:true,
                                    },
                                    ["冷流股出口压力"]:{
                                      ...prev["冷流股出口压力"],
                                      show:false,
                                    },
                                    ["热流股出口压力"]:{
                                      ...prev["热流股出口压力"],
                                      show:true,
                                    },
                                  }));
                                }
                              }
                              else if(item?.p_name==="流股属性" && localParamValues["冷流出口温度"] && localParamValues["热流出口温度"] && localParamValues["冷流出口压力"] && localParamValues["热流出口压力"])
                              {
                                if(selectedValue==="冷流股")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue:selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["冷流出口温度"]:{
                                      ...prev["冷流出口温度"],
                                      show:true,
                                    },
                                    ["热流出口温度"]:{
                                      ...prev["热流出口温度"],
                                      show:false,
                                    },
                                    ["冷流出口压力"]:{
                                      ...prev["冷流出口压力"],
                                      show:true,
                                    },
                                    ["热流出口压力"]:{
                                      ...prev["热流出口压力"],
                                      show:false,
                                    },
                                  }));
                                }
                                else if(selectedValue==="热流股")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue: selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["冷流出口温度"]:{
                                      ...prev["冷流出口温度"],
                                      show:false,
                                    },
                                    ["热流出口温度"]:{
                                      ...prev["热流出口温度"],
                                      show:true,
                                    },
                                    ["冷流出口压力"]:{
                                      ...prev["冷流出口压力"],
                                      show:false,
                                    },
                                    ["热流出口压力"]:{
                                      ...prev["热流出口压力"],
                                      show:true,
                                    },
                                  }));
                                }
                              }
                              else if(item?.p_name==="内部类型" && localParamValues["塔盘类型"] && localParamValues["填料类型"] && localParamValues["塔板数"] && localParamValues["有效孔面积比"] && localParamValues["堰高"] && localParamValues["塔板材质"] && localParamValues["溢流类型"] && localParamValues["填料高度"])
                              {
                                if(selectedValue==="塔板")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue:selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["塔盘类型"]:{
                                      ...prev["塔盘类型"],
                                      show:true,
                                    },
                                    ["塔板数"]:{
                                      ...prev["塔板数"],
                                      show:true,
                                    },
                                    ["有效孔面积比"]:{
                                      ...prev["有效孔面积比"],
                                      show:true,
                                    },
                                    ["堰高"]:{
                                      ...prev["堰高"],
                                      show:true,
                                    },
                                    ["塔板材质"]:{
                                      ...prev["塔板材质"],
                                      show:true,
                                    },
                                    ["溢流类型"]:{
                                      ...prev["溢流类型"],
                                      show:true,
                                    },

                                    ["填料类型"]:{
                                      ...prev["填料类型"],
                                      show:false,
                                    },
                                    ["填料高度"]:{
                                      ...prev["填料高度"],
                                      show:false,
                                    }
                                  }));
                                }
                                else if(selectedValue==="填料")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue: selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["塔盘类型"]:{
                                      ...prev["塔盘类型"],
                                      show:false,
                                    },
                                    // ["塔板数"]:{
                                    //   ...prev["塔板数"],
                                    //   show:false,
                                    // },
                                    ["有效孔面积比"]:{
                                      ...prev["有效孔面积比"],
                                      show:false,
                                    },
                                    ["堰高"]:{
                                      ...prev["堰高"],
                                      show:false,
                                    },
                                    ["塔板材质"]:{
                                      ...prev["塔板材质"],
                                      show:false,
                                    },
                                    ["溢流类型"]:{
                                      ...prev["溢流类型"],
                                      show:false,
                                    },


                                    ["填料类型"]:{
                                      ...prev["填料类型"],
                                      show:true,
                                    },
                                    ["填料高度"]:{
                                      ...prev["填料高度"],
                                      show:true,
                                    }
                                  }));
                                }
                                else if(selectedValue==="混合")
                                {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue: selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["塔盘类型"]:{
                                      ...prev["塔盘类型"],
                                      show:true,
                                    },
                                    ["塔板数"]:{
                                      ...prev["塔板数"],
                                      show:true,
                                    },
                                    ["有效孔面积比"]:{
                                      ...prev["有效孔面积比"],
                                      show:true,
                                    },
                                    ["堰高"]:{
                                      ...prev["堰高"],
                                      show:true,
                                    },
                                    ["塔板材质"]:{
                                      ...prev["塔板材质"],
                                      show:true,
                                    },
                                    ["溢流类型"]:{
                                      ...prev["溢流类型"],
                                      show:true,
                                    },

                                    ["填料类型"]:{
                                      ...prev["填料类型"],
                                      show:true,
                                    },
                                    ["填料高度"]:{
                                      ...prev["填料高度"],
                                      show:true,
                                    }
                                  }));
                                }
                              }
                              else if(item?.p_name==="操作规范" && localParamValues["操作规范值"])
                              {
                                if(selectedValue==="塔底物流率")
                                {
                                  let newUnits = ["kmol/hr","kg/hr","cum/hr"];
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue:selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["操作规范值"]:{
                                      ...prev["操作规范值"],
                                      unit:newUnits[0],
                                    }
                                  }));
                                }
                                else if(selectedValue==="再沸器负荷")
                                {
                                  let newUnits = ["Gcal/hr","kW"];
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      value: selectedValue,
                                      desValue:selectedValue,
                                      show: item.p_show ?? false,
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                    ["操作规范值"]:{
                                      ...prev["操作规范值"],
                                      unit:newUnits[0],
                                    }
                                  }));
                                }
                              }
                              else
                              {
                                setLocalParamValues((prev) => ({
                                  ...prev,
                                  [item?.p_name]: {
                                    value: selectedValue,
                                    desValue: selectedValue,
                                    show: localParamValues[item?.p_name].show??(item.p_show ?? false),
                                    engName: item.p_engName ?? "",
                                    unitField: item.p_unitField ?? null,
                                  },
                                }));
                              }
                            }}
                            style={{ flex: 1 }}
                            options={item.enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                          />
                        ) : (
                          <>
                            {item?.p_name!=="说明文本" ? (<Input
                              value={
                                localParamValues[item?.p_name]?.value ??
                                // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                                ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                                ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                              }
                              onChange={(e) => {
                                setLocalParamValues((prev) => ({
                                  ...prev,
                                  [item?.p_name]: {
                                    ...prev[item?.p_name],
                                    value: e.target.value,
                                    show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                    engName: item.p_engName ?? "",
                                    unitField: item.p_unitField ?? null,
                                  },
                                }));

                                // //特殊处理
                                // if(item.p_engName==="N")
                                // {
                                //   let N = Number(e.target.value);
                                //   if (Number.isNaN(N))
                                //   {
                                //     N = null;
                                //   }
                                //   let Nos = localParamValues["出料流股位置"].p_children;
                                //   let Nss = localParamValues["进料流股位置"].p_children;
                                //   let NoValues = Nos.map(obj => obj["出料位置"].value);
                                //   let NsValues = Nss.map(obj => obj["进料位置"].value);
                                  
                                //   if(N && N>=1 && Number.isInteger(N))
                                //   {
                                //     //恢复状态
                                //     let newErrorInputs = [...errorInputs];
                                //     newErrorInputs = newErrorInputs.filter(i => i !== item.p_engName);

                                //     //判断No与Ns的值
                                //     for(let i=0;i<NoValues.length;i++)
                                //     {
                                //       let value = Number(NoValues[i]);
                                //       if (Number.isNaN(value))
                                //       {
                                //         value = null;
                                //       }
                                //       if(value && value<=N && value>=1 && Number.isInteger(value))
                                //       {
                                //         newErrorInputs = newErrorInputs.filter(j => j !== `No_${i}`);
                                //       }
                                //       else
                                //       {
                                //         newErrorInputs.push(`No_${i}`);
                                //       }
                                //     }
                                //     for(let i=0;i<NsValues.length;i++)
                                //     {
                                //       let value = Number(NsValues[i]);
                                //       if (Number.isNaN(value))
                                //       {
                                //         value = null;
                                //       }
                                //       if(value && value<=N && value>=1 && Number.isInteger(value))
                                //       {
                                //         newErrorInputs = newErrorInputs.filter(j => j !== `Ns_${i}`);
                                //       }
                                //       else
                                //       {
                                //         newErrorInputs.push(`Ns_${i}`);
                                //       }
                                //     }

                                //     setErrorInputs(newErrorInputs);
                                //   }
                                //   else
                                //   {
                                //     //error状态
                                //     let newErrorInputs = [...errorInputs];
                                //     newErrorInputs.push(item.p_engName);

                                //     //如果N有误，则No与Ns都有误
                                //     for(let i=0;i<NoValues.length;i++)
                                //     {
                                //       newErrorInputs.push(`No_${i}`);
                                //     }
                                //     for(let i=0;i<NsValues.length;i++)
                                //     {
                                //       newErrorInputs.push(`Ns_${i}`);
                                //     }

                                //     setErrorInputs(newErrorInputs);
                                //   }
                                // }

                              }}
                              style={{ flex: 1 }}
                              status={errorInputs.includes(item.p_engName)?"error":""}
                            />):(
                              <Input.TextArea
                                autoSize={{maxRows:undefined}}
                                value={localParamValues[item?.p_name]?.value ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value}
                                onChange={(e) => 
                                {
                                  setLocalParamValues((prev) => 
                                  ({
                                    ...prev,
                                    [item?.p_name]: {
                                      ...prev[item?.p_name],
                                      value: e.target.value,
                                      show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                  }));
                                }}
                                style={{ flex: 1,minHeight:200,maxHeight:200}}
                              />
                            )}
                            
                            {designVisible ? (
                              <Input
                                value={
                                  localParamValues[item?.p_name]?.desValue ??
                                  // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                                  ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                                  ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                                }
                                onChange={(e) => {
                                  setLocalParamValues((prev) => ({
                                    ...prev,
                                    [item?.p_name]: {
                                      ...prev[item?.p_name],
                                      desValue: e.target.value,
                                      show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                      engName: item.p_engName ?? "",
                                      unitField: item.p_unitField ?? null,
                                    },
                                  }));
                                }}
                                style={{ flex: 1,marginLeft:10 }}
                              />
                            ):null}
                            {item.p_unit && Array.isArray(item.p_unit) && item.p_unit.length > 0 ? (
                              <Select
                                value={localParamValues[item?.p_name]?.unit}
                                onChange={(selectedUnit) => {
                                  const unitField = item.p_unitField;
                                  let newValues = { ...localParamValues };
                                  if (unitField) {
                                    const sameFieldParams = modalParams
                                      .filter((p: any) => p.p_unitField === unitField)
                                      .map((p: any) => p.p_name);
                                    sameFieldParams.forEach((paramName: string) => {
                                      newValues[paramName] = {
                                        ...newValues[paramName],
                                        unit: selectedUnit,
                                      };
                                    });
                                  } else {
                                    newValues[item.p_name] = {
                                      ...newValues[item.p_name],
                                      unit: selectedUnit,
                                    };
                                  }
                                  setLocalParamValues(newValues);
                                }}
                                style={{ marginLeft: "10px", width: "100px" }}
                                //特殊处理
                                options={item.p_engName!=="operatingSpecificationsValue" ? (item.p_unit.filter((unit: string) => {
                                  //流量单位 Nm3/h 仅在流股相态为汽相(V)时显示
                                  if (item.p_engName === "f" && unit === "Nm3/h") {
                                    return localParamValues["相态"]?.value === "V";
                                  }
                                  return true;
                                }).map((unit: string) => ({ label: unit, value: unit }))) : 
                                  item.p_engName==="operatingSpecificationsValue" ? 
                                  (localParamValues[item.p_name]?.unit==="kmol/hr"||localParamValues[item.p_name]?.unit==="kg/hr"||localParamValues[item.p_name]?.unit==="cum/hr" ? (item.p_unit_1.map((unit: string) => ({ label: unit, value: unit }))) : (localParamValues[item.p_name]?.unit==="Gcal/hr"||localParamValues[item.p_name]?.unit==="kW" ? (item.p_unit_2.map((unit: string) => ({ label: unit, value: unit }))) : (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) ) )
                                  : (item.p_unit.map((unit: string) => ({ label: unit, value: unit })))
                                }
                              />
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                  </div>
                ))}
              
              {modalParams &&
                Array.isArray(modalParams) &&
                modalParams.filter(item=>item.p_class).length>0 &&
                (Array.from(new Set(modalParams.filter(item => item.p_class).map(obj => obj["p_class"])))).map((fieldClassName) => 
                {
                  const itemsInCategory = modalParams.filter(item => item.p_class === fieldClassName);
                  // 判断是否有任意一项需要显示
                  const hasAnyShow = itemsInCategory.some(item => localParamValues[item.p_name]?.show === true);

                  return (
                    <div style={{display:hasAnyShow ?"flex":"none",flexDirection:"column" }}>
                      <div style={{fontSize: 14,fontWeight: "bold",color: "#1b6ae7",marginBottom:10}}>
                        {fieldClassName}
                      </div>
                      <div style={{border:"1px solid #BBB",marginBottom:20,paddingLeft:10,paddingRight:10,paddingTop:10}}>
                        {modalParams &&
                          Array.isArray(modalParams) &&
                          modalParams.filter(item=>item.p_class===fieldClassName).map((item) => (
                            <div
                              key={item?.p_name}
                              style={{
                                display: item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: item.p_show||localParamValues[item.p_name]?.show ? "10px" : "0px",
                              }}
                            >
                              {item.p_children && Array.isArray(item.p_children) && item.p_children.length > 0 ? (
                                <div style={{ width: "100%", marginBottom: "10px" }}>
                                </div>
                              ) : (
                                <>
                                  <div style={{ width: "120px", fontSize: 14 }}>{item?.p_name}</div>
                                  {item.enum && Array.isArray(item.enum) && item.enum.length > 0 ? (
                                    <Select
                                      value={localParamValues[item?.p_name]?.value}
                                      onChange={(selectedValue) => 
                                      {
                                        //特殊处理
                                        if(item?.p_name==="内部类型" && localParamValues["塔盘类型"] && localParamValues["填料类型"] && localParamValues["塔板数"] && localParamValues["有效孔面积比"] && localParamValues["堰高"] && localParamValues["塔板材质"] && localParamValues["溢流类型"] && localParamValues["填料高度"])
                                        {
                                          if(selectedValue==="塔板")
                                          {
                                            setLocalParamValues((prev) => ({
                                              ...prev,
                                              [item?.p_name]: {
                                                value: selectedValue,
                                                desValue:selectedValue,
                                                show: item.p_show ?? false,
                                                engName: item.p_engName ?? "",
                                                unitField: item.p_unitField ?? null,
                                              },
                                              ["塔盘类型"]:{
                                                ...prev["塔盘类型"],
                                                show:true,
                                              },
                                              // ["塔板数"]:{
                                              //   ...prev["塔板数"],
                                              //   show:true,
                                              // },
                                              ["有效孔面积比"]:{
                                                ...prev["有效孔面积比"],
                                                show:true,
                                              },
                                              ["堰高"]:{
                                                ...prev["堰高"],
                                                show:true,
                                              },
                                              ["塔板材质"]:{
                                                ...prev["塔板材质"],
                                                show:true,
                                              },
                                              ["溢流类型"]:{
                                                ...prev["溢流类型"],
                                                show:true,
                                              },

                                              ["填料类型"]:{
                                                ...prev["填料类型"],
                                                show:false,
                                              },
                                              ["填料高度"]:{
                                                ...prev["填料高度"],
                                                show:false,
                                              }
                                            }));
                                          }
                                          else if(selectedValue==="填料")
                                          {
                                            setLocalParamValues((prev) => ({
                                              ...prev,
                                              [item?.p_name]: {
                                                value: selectedValue,
                                                desValue: selectedValue,
                                                show: item.p_show ?? false,
                                                engName: item.p_engName ?? "",
                                                unitField: item.p_unitField ?? null,
                                              },
                                              ["塔盘类型"]:{
                                                ...prev["塔盘类型"],
                                                show:false,
                                              },
                                              // ["塔板数"]:{
                                              //   ...prev["塔板数"],
                                              //   show:false,
                                              // },
                                              ["有效孔面积比"]:{
                                                ...prev["有效孔面积比"],
                                                show:false,
                                              },
                                              ["堰高"]:{
                                                ...prev["堰高"],
                                                show:false,
                                              },
                                              ["塔板材质"]:{
                                                ...prev["塔板材质"],
                                                show:false,
                                              },
                                              ["溢流类型"]:{
                                                ...prev["溢流类型"],
                                                show:false,
                                              },


                                              ["填料类型"]:{
                                                ...prev["填料类型"],
                                                show:true,
                                              },
                                              ["填料高度"]:{
                                                ...prev["填料高度"],
                                                show:true,
                                              }
                                            }));
                                          }
                                          else if(selectedValue==="混合")
                                          {
                                            setLocalParamValues((prev) => ({
                                              ...prev,
                                              [item?.p_name]: {
                                                value: selectedValue,
                                                desValue: selectedValue,
                                                show: item.p_show ?? false,
                                                engName: item.p_engName ?? "",
                                                unitField: item.p_unitField ?? null,
                                              },
                                              ["塔盘类型"]:{
                                                ...prev["塔盘类型"],
                                                show:true,
                                              },
                                              // ["塔板数"]:{
                                              //   ...prev["塔板数"],
                                              //   show:true,
                                              // },
                                              ["有效孔面积比"]:{
                                                ...prev["有效孔面积比"],
                                                show:true,
                                              },
                                              ["堰高"]:{
                                                ...prev["堰高"],
                                                show:true,
                                              },
                                              ["塔板材质"]:{
                                                ...prev["塔板材质"],
                                                show:true,
                                              },
                                              ["溢流类型"]:{
                                                ...prev["溢流类型"],
                                                show:true,
                                              },

                                              ["填料类型"]:{
                                                ...prev["填料类型"],
                                                show:true,
                                              },
                                              ["填料高度"]:{
                                                ...prev["填料高度"],
                                                show:true,
                                              }
                                            }));
                                          }
                                        }
                                        else
                                        {
                                          setLocalParamValues((prev) => ({
                                            ...prev,
                                            [item?.p_name]: {
                                              value: selectedValue,
                                              desValue: selectedValue,
                                              show: localParamValues[item?.p_name].show??(item.p_show ?? false),
                                              engName: item.p_engName ?? "",
                                              unitField: item.p_unitField ?? null,
                                            },
                                          }));
                                        }
                                      }}
                                      style={{ flex: 1 }}
                                      options={item.enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                                    />
                                  ) : (
                                    <>
                                      {item?.p_name!=="说明文本" ? (<Input
                                        value={
                                          localParamValues[item?.p_name]?.value ??
                                          // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                                          ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                                          ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                                        }
                                        onChange={(e) => {
                                          setLocalParamValues((prev) => ({
                                            ...prev,
                                            [item?.p_name]: {
                                              ...prev[item?.p_name],
                                              value: e.target.value,
                                              show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                              engName: item.p_engName ?? "",
                                              unitField: item.p_unitField ?? null,
                                            },
                                          }));

                                        }}
                                        style={{ flex: 1 }}
                                        status={errorInputs.includes(item.p_engName)?"error":""}
                                      />):(
                                        <div>
                                        </div>
                                      )}
                                      {item.p_unit && Array.isArray(item.p_unit) && item.p_unit.length > 0 ? (
                                        <Select
                                          value={localParamValues[item?.p_name]?.unit}
                                          onChange={(selectedUnit) => {
                                            const unitField = item.p_unitField;
                                            let newValues = { ...localParamValues };
                                            if (unitField) {
                                              const sameFieldParams = modalParams
                                                .filter((p: any) => p.p_unitField === unitField)
                                                .map((p: any) => p.p_name);
                                              sameFieldParams.forEach((paramName: string) => {
                                                newValues[paramName] = {
                                                  ...newValues[paramName],
                                                  unit: selectedUnit,
                                                };
                                              });
                                            } else {
                                              newValues[item.p_name] = {
                                                ...newValues[item.p_name],
                                                unit: selectedUnit,
                                              };
                                            }
                                            setLocalParamValues(newValues);
                                          }}
                                          style={{ marginLeft: "10px", width: "100px" }}
                                          //特殊处理
                                          options={item.p_engName!=="operatingSpecificationsValue" ? (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) : 
                                            item.p_engName==="operatingSpecificationsValue" ? 
                                            (localParamValues[item.p_name]?.unit==="kmol/hr"||localParamValues[item.p_name]?.unit==="kg/hr"||localParamValues[item.p_name]?.unit==="cum/hr" ? (item.p_unit_1.map((unit: string) => ({ label: unit, value: unit }))) : (localParamValues[item.p_name]?.unit==="Gcal/hr"||localParamValues[item.p_name]?.unit==="kW" ? (item.p_unit_2.map((unit: string) => ({ label: unit, value: unit }))) : (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) ) )
                                            : (item.p_unit.map((unit: string) => ({ label: unit, value: unit })))
                                          }
                                        />
                                      ) : null}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  )
                }
              )}

              {materialsData &&
                typeof materialsData === "object" &&
                !Array.isArray(materialsData) &&
                localFormData["流股名称"] &&
                globalData &&
                globalData.materials &&
                globalData.materials.length > 0 && (
                  <div style={{display:"flex",flexDirection:"row",alignItems: "center",marginBottom:10}}>
                    <div
                      style={{
                        width: "120px",
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "#1b6ae7",
                      }}
                    >
                      组分摩尔分率
                    </div>
                    <Button type="text" style={{height: 30,width: 30,borderRadius: 50,backgroundColor: "#FFF",marginLeft: "auto"}}
                      onClick={() =>{setModalVariable(true);}}
                    >
                      <CopyOutlined style={{ fontSize: 18, color: "#1b6ae7" }} />
                    </Button>
                  </div>
                )}
              {materialsData &&
                typeof materialsData === "object" &&
                !Array.isArray(materialsData) &&
                localFormData["流股名称"] &&
                globalData &&
                globalData.materials &&
                globalData.materials.map((item: any) => (
                  <div
                    key={item.formula}
                    style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
                  >
                    <div
                      style={{ width: "120px", fontSize: 14 }}
                    >{`${rebuildFormula(item.formula)}（${item.name}）`}</div>
                    <Input
                      value={localMaterialsData[item.formula]?.molar_frac ?? (localMaterialsData[item.formula].molar_frac===0 ? (localMaterialsData[item.formula].molar_frac): "")}
                      onChange={(e) => {
                        setLocalMaterialsData((prev) => ({
                          ...prev,
                          [item.formula]: {
                            molar_frac: e.target.value,
                            desValue: localMaterialsData[item.formula]?.desValue ?? item.desValue,
                            cas: localMaterialsData[item.formula]?.cas_code ?? item.cas_code,
                            name: localMaterialsData[item.formula]?.formula ?? item.formula,
                            chineseName: localMaterialsData[item.formula]?.name ?? item.name,
                          },
                        }));
                      }}
                      style={{ flex: 1 }}
                    />
                    {(designVisible?(
                      <Input
                        value={localMaterialsData[item.formula]?.desValue ?? ""}
                        onChange={(e) => {
                          setLocalMaterialsData((prev) => ({
                            ...prev,
                            [item.formula]: {
                              molar_frac: localMaterialsData[item.formula]?.molar_frac ?? item.molar_frac,
                              desValue: e.target.value,
                              cas: localMaterialsData[item.formula]?.cas_code ?? item.cas_code,
                              name: localMaterialsData[item.formula]?.formula ?? item.formula,
                              chineseName: localMaterialsData[item.formula]?.name ?? item.name,
                            },
                          }));
                        }}
                        style={{flex:1,marginLeft:10}}
                      />
                    ):null)}
                  </div>
                ))}
            </div>
          </div>
        </div> */}

        <div style={{display:"flex",flexDirection:"row",height:35,marginLeft:20,marginRight:20,marginBottom:10}}>
            <button
                onClick={async() => {
                  let oldParams =  await upOldParams();
                  confirm(oldParams);
                }}
                style={{display:"flex",alignItems:"center",justifyContent: "center",width:90,border:0,borderRadius:5,backgroundColor:"#1b6ae7",color:"#FFF",fontSize:12}}
            >
                确认
            </button>
            
            <button
                onClick={() => {cancel();}}
                style={{display:"flex",alignItems:"center",justifyContent: "center",width:90,marginLeft:15,border:"1px solid #1b6ae7",borderRadius:5,backgroundColor:"#FFF",color:"#1b6ae7",fontSize:12}}
            >
                取消
            </button>
        </div>

        <Modal
            zIndex={2000}
            closable={false}
            centered={true}
            footer={null}
            width={500}
            className={"modal"}
            open={modalVariable}
            onCancel={()=>{setModalVariable(false);setCopyMaterialsDataTxt("");}}
        >
            <div style={{marginBottom:20,fontSize:20,fontWeight:"bold",color:"#1b6ae7"}}>粘贴组分摩尔分率</div>
            <div>
            <Input.TextArea
                autoSize={{maxRows:undefined}}
                value={copyMaterialsDataTxt}
                onChange={(e) => {setCopyMaterialsDataTxt(e.target.value);}}
                style={{ flex: 1,minHeight:400,maxHeight:400}}
            />
            </div>
            <div style={{height:32}}>
            <button
                onClick={()=>{{setModalVariable(false);setCopyMaterialsDataTxt("");}}}
                style={{position:"absolute",right:25,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#FF4D4F",color:"#FFF",fontSize:14}}
            >取消</button>
            <button
                onClick={async()=>{
                    let res = await copyMaterialsData();
                    if(res)
                    {
                        setModalVariable(false);
                        setCopyMaterialsDataTxt("");
                    }
                }}
                style={{position:"absolute",right:138,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#1b6ae7",color:"#FFF",fontSize:14}}
            >确认</button>
            </div>
        </Modal>
        
        {/* 选择特殊效率弹窗 */}
        <Modal
            zIndex={2000}
            closable={false}
            centered={true}
            footer={null}
            width={500}
            className={"modal"}
            open={selectSpecModal?.variable}
            onCancel={()=>{setSelectSpecModal({variable:false,index:null});}}
        >
            <div style={{marginBottom:20,fontSize:20,fontWeight:"bold",color:"#1b6ae7"}}>选择特殊效率组分</div>
            <div>
            <Checkbox.Group
              options={globalData.materials.map(obj => obj["name"])}
              value={specChecked}
              onChange={(vals) => setSpecChecked(vals as string[])}
              style={{ width: "100%", maxHeight: 300, overflowY: "auto", marginBottom: 20 }}
            >
            </Checkbox.Group>
            </div>
            <div style={{height:32}}>
            <button
                onClick={()=>{{setSelectSpecModal({variable:false,index:null});}}}
                style={{position:"absolute",right:25,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#FF4D4F",color:"#FFF",fontSize:14}}
            >取消</button>
            <button
                onClick={()=>{
                    const idx = selectSpecModal?.index;
                    setSelectSpecModal({variable:false,index:null});
                    if (idx == null || !paramDatas) return;
                    // 定位塔板效率 eff 参数
                    const effParam = paramDatas.find((cd: any) => cd.className === "塔板效率")?.params?.find((p: any) => p.engName === "eff");
                    if (!effParam) return;
                    const effChildren = effParam.children || [];
                    // 按勾选的组分重建特殊效率数组（保留原有已填的效率值）
                    const newSpec = (globalData.materials || [])
                        .filter((m) => specChecked.includes(m.name))
                        .map(m => {
                            // 从打开弹窗时的原始 children 找回已填的效率值
                            const exist = specOriginChildrenRef.current.find((sp: any) => sp?.["组分"]?.value === m.name);
                            return {
                                组分: { value: m.name, show: true, engName: "组分", readonly: true,},
                                效率值: { value: exist?.["效率值"]?.value ?? "", desValue: exist?.["效率值"]?.desValue ?? "", show: true, engName: "效率值" }
                            };
                        });
                    const newChildren = effChildren.map((item: any, i: number) => i === idx ? {...item, "特殊效率": {...item["特殊效率"], children: newSpec}} : item);
                    upParamData("eff", {children: newChildren});

                    let newExpandEffRow = structuredClone(expandEffRow);
                    newExpandEffRow.push(idx);
                    setExpandEffRow(newExpandEffRow);
                }}
                style={{position:"absolute",right:138,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#1b6ae7",color:"#FFF",fontSize:14}}
            >确认</button>
            </div>
        </Modal>

      </div>
    );
  }
};

export default ParameterEditor;